export const es = {
  Enums: {
    ProcessType: {
      MassCommand: 'Comando Masivo',
      MassMeterRegistration: 'Importación Masiva de Medidores',
      MassMeterEdit: 'Edición Masiva de Medidores',
      ScheduleRecoverMassMemorySmc: 'Recuperación Programada de Memoria Masiva SMC',
      ScheduledCommand: 'Comando Programado',
    },
    maxPhaseUnbalanceCurve: 'Curva de Desbalance de Fase Máximo',
    AccountStatus: {
      DISABLED: 'Desactivado',
      ACTIVATED: 'Activado',
      NO_RELE: 'Sin Relé',
      NO_INFORMATION: 'Sin Información',
      maxPhaseUnbalanceCurve: 'Curva de Desbalance de Fase Máximo',
      ALL: 'Todo',
    },
    TicketStatus: {
      Cancelled: 'Cancelado',
      CommandTimeOutReached: 'Tiempo de Ejecución Excedido',
      Executing: 'Ejecutando',
      Failed: 'Falló',
      FailedToContinue: 'Error durante el procesamiento',
      FailedToStart: 'Falla al inicializar',
      Finished: 'Ejecutado con Éxito',
      Success: 'Ejecutado con Éxito',
      Interupted: 'Interrumpido',
      MiddleWareOffline: 'MiddleWare Offline o No Disponible',
      MiddlewareNotResponding: 'Sin respuesta del MiddleWare',
      PartiallyFinished: 'Finalizado Parcialmente',
      Waiting: 'Esperando',
      WaitingScheduleDateTime: 'Esperando fecha y hora programada',
      SystemTimeout: 'Tiempo del sistema Excedido',
      Timeout: 'Tiempo de Solicitud Excedido',
      OutsideAllowedTime: 'Período no permitido',
    },
    StatusCommand: {
      DATA_BLOCK_UNAVAILABLE: 'Bloque de datos no disponible',
      DAT_BLOCK_NUMBER_INVALID: '¡Número de bloque inválido!',
      HARDWARE_FAULT: 'Falla de Hardware',
      INCOMPLETE: 'Incompleto',
      INCORRECT_KEYS: 'Claves Incorrectas',
      INTERRUPTED_BY_COMMISSIONING: 'Interrumpido por comisionamiento',
      INVALID_ITEM: 'Ítem inválido',
      LONG_GET_ABORTED: 'Get Long Abortado',
      LONG_SET_ABORTED: 'Set Long Abortado',
      METERS_NOT_MATCH_WITH_RECEIVED: 'Lista de medidores inválida',
      NO_LONG_GET_IN_PROGRESS: 'Ningún Get Long en progreso',
      NO_LONG_SET_IN_PROGRESS: 'Ningún Set Long en progreso',
      OBJECT_CLASS_INCONSISTENT: 'Clase del Objeto Inconsistente',
      OBJECT_UNAVAILABLE: 'Objeto no disponible',
      OBJECT_UNDEFINED: 'Objeto Indefinido',
      OPEN_DOOR: 'Puerta Abierta',
      OTHER_REASON: 'Otras Razones',
      READ_WRITE_DENIED: 'Lectura o Escritura Denegada',
      SCOPE_OF_ACCESS_VIOLATED: 'Violación del Alcance de Acceso',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configuración del Intervalo de Captura de Long Out Event',
      SET_INTERVAL_OF_QEE: 'Configuración del Intervalo de Captura de DRP/DRC',
      SET_STANDARD_FROZEN_DATA: 'Configuración de la Plantilla de Energía estándar',
      SUCESS: 'Ejecutado con Éxito',
      TEMPORARY_FAILURE: 'Falla Temporal',
      TIMEOUT: 'Tiempo Máximo de Ejecución Alcanzado',
      SYSTEMTIMEOUT: 'Tiempo de Ejecución Excedido',
      TYPE_UNMATCHED: 'Tipo Inconsistente',
      WAITING: 'Esperando Respuesta',
      EXECUTING: 'Ejecutando',
      NO_COMISSIONED: 'Comisión no registrada',
      SCHEDULED: 'Programado',
      SENT: 'Enviado',
      FINISHED: 'Finalizado',
      CANCELLED: 'Cancelado',
      SUCCESS: 'Ejecutado con éxito',
      COMMUNICATIONERROR: 'Error de comunicación',
      EXECUTIONERROR: 'Error de ejecución',
      INTERNALERROR: 'Error interno',
      INVALID_METERS: 'Medidor(es) inválido(s)',
      ACKNOWLEDGMENT: 'Reconocimiento simple',
      INVALID_SCHEMA: 'Formato de solicitud inválido',
      DATA_UNAVAILABLE: 'Datos no disponibles',
      NOT_SUPPORTED: 'Funcionalidad no soportada',
      INVALIDMETER: 'Medidor inválido',
      CUT_AT_IMPROPER_TIME: 'Period not allowed',
    },
    CommandType: {
      DisableCollectiveCut: 'Autorizar Apertura de Puertas',
      EnableCollectiveCut: 'Desactivar Apertura de Puerta',
      GetQEEIndicator: 'Solicitar parámetros de calidad',
      GetVoltageOutLong: 'Obtener Alarma Voltage Out Long',
      GetVoltageOutShort: 'Obtener Alarma Voltage Out Short',
      ImportFrozenData: 'Importar Totalizadores de Energía',
      ImportMassMemory: 'Importar Memoria de Masa',
      ImportQEEIndicator: 'Importar Parámetros de Calidad',
      ImportVoltageOutAlarm: 'Importar Alarmas de Voltage Out',
      InstantMeasure: 'Solicitar Energía Instantánea',
      ListMetersSmcSerial: 'Solicitar Medidores del SMC',
      MarkAlarmAsRead: 'Marcar Alarma Como Leída',
      MeterAddedToSmc: 'Agregar medidor al smc (Sistema)',
      MeterRemovedFromSmc: 'Remover medidor del smc (Sistema)',
      NicReset: 'Reset de la NIC',
      RecoverEventQeeIndicator: 'Recuperar indicadores de calidad',
      RecoverFrozenData: 'Recuperar Totalizadores de Energía',
      RecoverGbtMessage: 'GBT',
      RecoverMassMemory: 'Recuperar Memoria de Masa',
      RelayOff: 'Desactivar el Relé',
      RelayOn: 'Activar el Relé',
      RelayOnAllMetersOfSmc: 'Reconectar Todos los Clientes',
      RelayStatus: 'Obtener estado del Relé',
      SmiInfoRequest: 'Obtener información del medidor',
      RequestDoorStatus: 'Obtener Estado del Corte Colectivo',
      RequestRelayStatusAllSmc: 'Solicitar Estado del Relé de Todos los Medidores',
      Rollback: 'Rollback',
      SendKeyAk: 'Envío de Claves de autenticación para los medidores',
      SendKeyEk: 'Envío de Claves de cifrado para los medidores',
      GetCellIDAndIP: 'Obtener Cell ID e IP',
      SetDatetime: 'Establecer Fecha y Hora del SMC',
      SetIntervalOLongOutEvent: 'Configuración del Intervalo de Captura de Long Out Event',
      SetIntervalOfQee: 'Configuración del Intervalo de Captura de DRP/DRC',
      SetStandardFrozenData: 'Configuración de la Plantilla de Energía estándar',
      Set_Current: 'Modificar corriente de corte',
      UpdateDateTime: 'Actualizar Fecha y Hora',
      ReadDateTime: 'Lectura Fecha y Hora',
      UplinkPeriod: 'Cambiar Período de Lectura de Uplink',
      DoorStatusAbsolute: 'Obtener estado de la puerta',
      SetSmiVoltage: 'Establecer tensión de referencia',
      SetDisplayConfiguration: 'Establecer Configuración de Display Auto',
      SetDisplayConfigurationManual: 'Establecer Configuración de Display Manual',
      SetDisplayConfigurationMicromax: 'Establecer Configuración de Display Auto MicroMax',
      SetDisplayConfigurationManualMicromax: 'Establecer Configuración de Display Manual MicroMax',
      GetSmiVoltage: 'Obtener tensión de referencia',
      MeterRecoverEventQeeIndicator: 'Recuperar Parámetros de Calidad',
      SetQualityMeasureParams: 'Recuperar Parámetros de Calidad',
      GetQeeBuffer: 'Obtener buffer Qee',
      GetEnergyTotalizer: 'Solicitar Energía Activa Directa',
      MassRegistration: 'Registro en Masa',
      MassEdit: 'Edición en Masa',
      ChangeNetworkType: 'Cambiar tipo de red',
      GetNetworkType: 'Obtener tipo de red',
      GetNetworkInfo: 'Obtener tipo de tecnología',
      ChangeNetworkTech: 'Cambiar tipo de tecnología',
      GetDaylightSavingsEnabled: 'Obtener estado horario de verano',
      GetDaylightSavingsEnd: 'Obtener final horario de verano',
      GetDaylightSavingsDeviation: 'Obtener alteración horario de verano',
      GetDaylightSavingsBegin: 'Obtener inicio horario de verano',
      GetSpecialDaysTable: 'Obtener días festivos',
      SetSpecialDaysTable: 'Agregar días festivos',
      DeleteSpecialDays: 'Eliminar días festivos',
      GetDmrcSwitch: 'Solicitar switch DMRC y UFER',
      SetDmrcSwitch: 'Establecer switch DMRC y UFER',
      SetDayPassiveActivityCalendar: 'Agregar día calendario pasivo',
      SetWeekPassiveActivityCalendar: 'Agregar semana calendario pasivo',
      ActivatePassiveTimeCalendarActivityCalendar: 'Agregar tiempo para activación',
      SetDayProfilePassiveCalendarActivityCalendar: 'Agregar día calendario pasivo DMRC',
      DrmcSetWeekProfilePassiveCalendarActivityCalendar: 'Agregar semana calendario pasivo DMRC',
      DrmcGetDayProfilePassiveActivityCalendar: 'Solicitar días del calendario pasivo DMRC',
      DrmcGetActivatePassiveTimeCalendarActivityCalendar:
        'Solicitar tiempo de activación calendario pasivo DMRC',
      GetActivatePassiveTimeCalendarActivityCalendar:
        'Solicitar tiempo de activación calendario pasivo',
      GetWeekProfilePassiveActivityCalendar: 'Solicitar semana del calendario pasivo',
      GetWeekProfileActiveActivityCalendar: 'Solicitar semana del calendario activo',
      GetDayProfileActiveActivityCalendar: 'Solicitar días del calendario activo',
      GetDayProfilePassiveActivityCalendar: 'Solicitar días del calendario pasivo',
      DrmcGetWeekProfileActiveActivityCalendar: 'Solicitar semana del calendario activo DMRC',
      DrmcGetWeekProfilePassiveActivityCalendar: 'Solicitar semana del calendario pasivo DMRC',
      DrmcGetDayProfileActiveActivityCalendar: 'Solicitar días del calendario activo DMRC',
      DrmcActivatePassiveTimeCalendarActivityCalendar: 'Agregar tiempo para activación DMRC',
      SetActivatePassiveCalendarActivityCalendar: 'Definir estado de perfil DMRC',
      ActivatePassiveCalendarActivityCalendar: 'Definir estado de perfil',
      SetDaylightSavingsEnabled: 'Definir estado horario de verano',
      SetDaylightSavingsDeviation: 'Definir alteración horario de verano',
      SetDaylightSavingsBegin: 'Definir inicio horario de verano',
      SetDaylightSavingsEnd: 'Definir final horario de verano',
      GetTaxPage: 'Recuperar Página Fiscal',
      GetDemandRegisters: 'Recuperar registradores',
      GetGeneralReadingValues: 'Recuperar lecturas',
      DeactivateMeter: 'Desactivar medidor',
      AddMeterToGateway: 'Agregar Medidor al Gateway',
      RemoveMeterFromGateway: 'Remover Medidor del Gateway',
      ListMetersFromGateway: 'Listar Medidores del Gateway',
      ReadDisplayConfiguration: 'Solicitar Configuración de Display',
      ReadDatetime: 'Lectura de Fecha y Hora',
      GetDailyBilling: 'Obtener Facturación Diaria',
      GetLoadProfile: 'Obtener Perfil de Carga',
      GetFiscalPage: 'Obtener Página Fiscal',
      ReprocessBilling: 'Reprocesar Facturación',
      ReprocessCutRelay: 'Reprocesar Corte/Reconexion',
      ReprocessDetailUc: 'Reprocesar Detalles de la Unidad de Consumo',
      VoltageInterruptionMonthly: 'Obtener Interrupción de Tensión Mensual',
      DrpDrcMonthly: 'Obtener DRP/DRC Mensual',
      DrpDrcCycle: 'Obtener Ciclo DRP/DRC',
      SetTariffConfiguration: 'Definir Tipo de Tarifa',
      DeviceReset: 'Reinicio de dispositivo',
      RecoverMonitoring: 'Perfil de Carga (Energía + Memoria de Masa)',
      InfoRequest: 'Solicitar información general',
      RequestConfiguration: 'Solicitar configuración',
      GetBlockSize: 'Obtener Tamaño del Bloque',
      ImageTransferInitiate: 'Iniciar Transferencia de Imagen',
      ImageTransferData: 'Datos de Transferencia de Imagen',
      GetFirstBlockNotTransferred: 'Obtener Primer Bloque No Transferido',
      ImageTransferVerify: 'Verificar Transferencia de Imagen',
      ImageTransferActivate: 'Activar Transferencia de Imagen',
      UpdateFirmware: 'Actualizar Firmware',
      UploadFirmware: 'Cargar Firmware',
      GetHardwareInfo: 'Obtener Información de Hardware',
      ReadNicInfo: 'Leer Información del NIC',
      ReadNicSetup: 'Leer Configuración del NIC',
      ReadRelay: 'Leer Relé',
      ReadTimestamp: 'Leer Timestamp',
      ReadNicData: 'Leer Datos del NIC',
      NicSetup: 'Configuración del NIC',
      ReadLdrUpper: 'Leer LDR Superior',
      ReadLdrBottom: 'Leer LDR Inferior',
      ReadLdrMin: 'Leer LDR Mínimo',
      SetLdrUpper: 'Definir LDR Superior',
      SetLdrBottom: 'Definir LDR Inferior',
      SetLdrMin: 'Definir LDR Mínimo',
      ReadNicSerial: 'Leer Serial del NIC',
      ReadRelayWithLastSwitchOn: 'Leer Relé con Último Encendido',
      ReadRelayWithLastSwitchOnAndOff: 'Leer Relé con Último Encendido y Apagado',
      SetBlockSize: 'Definir Tamaño del Bloque',
      MulticastGroupSetup: 'Configuración de Grupo Multicast',
      MulticastClassCSession: 'Sesión Multicast Clase C',
      MulticastSetupConfirmation: 'Confirmación de Configuración Multicast',
      ImageTransferStatus: 'Estado de la Transferencia de Imagen',
      GetFirmwareVersion: 'Obtener Versión del Firmware',
      ReadAlarmFakeOnOff: 'Leer Alarma Falsa On/Off',
      ConfigureApplicationGroup: 'Configurar Grupo de Aplicación',
      ReadALarmLastGasp: 'Leer Alarma de Último Suspiro',
      SetLastGaspVoltageLevel: 'Definir Nivel de Tensión de Último Suspiro',
      ReadAlarmVoltageMonitor: 'Leer Monitor de Tensión de Alarma',
      SetVoltageMinimalInterval: 'Definir Intervalo Mínimo de Tensión',
      SetAlarmFakeOnOffThreshold: 'Definir Umbral de Alarma Falsa On/Off',
      ReadTemperatureValue: 'Leer Valor de Temperatura',
      ReadRelayWithDelay: 'Leer Relé con Retraso',
      DeviceCreated: 'Dispositivo creado',
      DeviceUpdated: 'Dispositivo actualizado',
      ScheduleCreated: 'Programación creada',
      scheduleUpdated: 'Programación actualizada',
      groupCreated: 'Grupo creado',
      groupUpdated: 'Grupo actualizado',
      setAlarmFakeOnOff: 'Alarma On/Off',
      scheduleCanceled: 'Programación cancelada',
      scheduleDeleted: 'Programación eliminada',
      deviceDeleted: 'Dispositivo eliminado',
      groupDeleted: 'Grupo eliminado',
      checkScheduleStatus: 'Verificar estado de la programación',
      activateSchedule: 'Activar programación',
      deactivateSchedule: 'Desactivar programación',
      checkScheduleExist: 'Verificar si existe la programación',
      readDeviceType: 'Leer tipo de dispositivo',
      writeDeviceRole: 'Asignar tipo de dispositivo',
      fullScheduleCommand: 'Comando de programación completo',
      scheduleCreatedOnSystem: 'Programación creada (Sistema)',
      activateScheduleOnSystem: 'Activar programación (Sistema)',
      checkScheduleStatusOnSystem: 'Verificar estado de la programación (Sistema)',
      writeDeviceRoleOnSystem: 'Asignar tipos de dispositivo (Sistema)',
      deactivateScheduleOnSystem: 'Desactivar programación (Sistema)',
      checkScheduleExistOnSystem: 'Verificar si existe la programación (Sistema)',
      readDeviceTypeOnSystem: 'Leer tipo de dispositivo (Sistema)',
      setDatetimeOnSystem: 'Actualizar Fecha y Hora (Sistema)',
      periodicConfiguration: 'Configuración de Periodicidad',
      decommissioning: 'Desmantelamiento',
      openSession: 'Abrir Sesión con Medidor',
      readMeterSerial: 'Leer Serial del Medidor',
      importMassMeters: 'Importar medidores en masa',
      saveConfig: 'Guardar configuración',
      readConfig: 'Leer configuración',
      saveTime: 'Guardar fecha y hora',
      timeCorrection: 'Corrección de hora',
      storage: 'Almacenamiento',
      fuotaPause: 'Pausa de actualización de firmware',
      deleteSpecialDays: 'Eliminar días festivos',
      getTotalizers: 'Leer totalizadores',
      getRelayStatusControl: 'Leer Estado de Control del Relé',
      setRelayStatusControl: 'Cambiar Estado de Control del Relé',
      getIntegrationInstantaneousReadings: 'Leer valores instantáneos',
      getVoltageOutLongShort: 'Obtener Alarma de Voltage Out Larga y corta',
      relayStatusOrca: 'Recuperar estado del relé orca',
      getQeeOnDemand: 'Solicitar parámetros de calidad por demanda',
      getQeeHistoricalData:
        'Solicitar el historial de lectura de datos de los parámetros de calidad',
      getLoadProfile: 'Leer datos de Memoria de masa',
      getDailyBilling: 'Leer datos de Energía',
      recoverFragmentedPacket: 'Recuperar datos fragmentados',
      drpDrcEventLog: 'Registro de eventos DRP y DRC',
      readTariffPeriods: 'Obtener Lectura de Tarifa',
      smartFuseAlarmAck: 'Alarma Ack',
      ImportAlarms: 'Importar Alarmas',
    },
    ServiceTypeEquatorial: {
      TurnOnPower: 'Reconectar',
      TurnOffPower: 'Corte',
      RequestRead: 'Solicitud de Lectura',
      RequestNoteLq: 'Solicitud de QEE',
    },
    RequestStatusEquatorial: {
      Waiting: 'Esperando',
      Processing: 'Procesando',
      Running: 'En Ejecución',
      CommunicationWithMDCFailed: 'Falla en la Comunicación con MDC',
      InternalFailure: 'Falla Interna',
      MDCTicketFinalized: 'Ticket MDC Finalizado',
      MDCTicketFailed: 'Ticket MDC Falló',
      FinishedWithSuccess: 'Finalizado con Éxito',
      FinishedWithFailure: 'Finalizado con Falla',
      Cancelled: 'Cancelado',
    },
    CommandStatus: {
      CHANGING_COLLECTIVE_CUT_ALARM: 'Cambiando el estado de corte Colectivo',
      CHANGING_RELAY_STATUS: 'Cambiando Estado del Relé',
      GBT: 'GBT',
      GET_QEE_INDICATORS: 'Solicitando parámetros de calidad',
      INSTANT_MEASURE: 'Solicitando medida Instantánea',
      MARK_ALARM_AS_READ: 'Marcando Alarma Como Leída',
      NIC_RESET: 'Reset de la NIC',
      RECOVER_EVENT_QEE_INDICATOR: 'Recuperando parámetros de calidad',
      RECOVER_FROZEN_DATA: 'Recuperando Totalizadores de Energía',
      RECOVER_MASS_MEMORY: 'Recuperando Memoria de Masa',
      REGISTERING_DATETIME: 'Registrando Fecha y Hora',
      REGISTERING_KEYS: 'Registrando Claves',
      RELAY_ON_ALL_METERS_SMC: 'Reconectando todos los clientes',
      REQUESTING_DATE: 'Solicitando Fecha',
      REQUESTING_RELAY_STATUS: 'Solicitando Estado del Relé',
      REQUESTING_RELAY_STATUS_ALL_SMC: 'Solicitando estado de los relés',
      REQUESTING_SERIAL: 'Solicitando Serial',
      REQUEST_DOOR_STATUS: 'Obteniendo Estado del corte colectivo',
      ROLLBACK: '¡Ejecutando RollBack!',
      SET_CURRENT: 'Modificando corriente de corte',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configurando Intervalo de Captura de Long Out',
      SET_INTERVAL_OF_QEE: 'Configurando Intervalo de Captura de DRP/DRC',
      SET_STANDARD_FROZEN_DATA: 'Configurando Plantilla de Energía estándar',
      UPLINK_PERIOD: 'Cambiando Período de Uplink de lectura',
      WAITING_COMMAND: 'Esperando Comando',
      SET_SMI_VOLTAGE: 'Configurando tensión de referencia',
      GET_VOLTAGE: 'Solicitando tensión de referencia',
      DOOR_STATUS_ABSOLUTE: 'Obteniendo estado de la puerta',
      SET_DISPLAY_CONFIGURATION: 'Configurando display auto',
      SET_DISPLAY_CONFIGURATION_MANUAL: 'Configurando display manual',
      METER_SET_QUALITY_MEASURE_PARAMS: 'Recuperando Parámetros de Calidad',
      METER_RECONVER_EVENT_QEE_INDICATOR: 'Recuperando Parámetros de Calidad',
      GET_QEE_BUFFER: 'Obteniendo tamaño del Buffer Qee',
      GET_ENERGY_TOTALIZER: 'Obteniendo Energía Activa Directa',
      CHANGING_NETWORK_TYPE: 'Cambiando tipo de Red',
      GETTING_NETWORK_TYPE: 'Obteniendo tipo de Red',
    },
    ComunicationStatus: {
      BUSY: 'Ocupado',
      COMMUNICATION_FAILED: 'Falla de Comunicación',
      NO_INFORMATION: 'Sin Información',
      SUCCESS: 'Éxito',
    },
    tariffsType: {
      tariff: 'Tarifa',
      IRRIGANTE: 'Irrigante',
      TARIFA_BRANCA: 'Tarifa Blanca',
      GD: 'Generación Distribuida',
      IRRIGANTE_GD: 'Irrigante Generación Distribuida',
      TARIFA_BRANCA_GD: 'Tarifa Blanca Generación Distribuida',
      CONVENCIONAL: 'Convencional',
      CONVENCIONAL_GD: 'Convencional Generación Distribuida',
      MMGD: 'MMGD',
      REN871: 'REN871',
      GRUPO_B_IRRIGANTE: 'Grupo B Irrigante',
      GRUPO_A: 'Grupo A',
      CLIENTE_LIVRE: 'Cliente Libre',
      TARIFA_BRANCA_MMGD: 'Tarifa Blanca + MMGD',
      TARIFA_BRANCA_MMGD_IRRIGANTE: 'Tarifa Blanca + MMGD + Irrigante',
      GRUPO_A_IRRIGANTE: 'Grupo A Irrigante',
    },
    MeterTypes: {
      Integration: 'Integración',
      IntegrationDcu: 'Integración Wasion DCU',
      Nepen: 'Integración MDX',
    },
    AlarmDescription: {
      POWER_RESTORE: 'Energía restaurada',
      TERMINAL_COVER_REMOVED_START: 'Inicio de remoción de tapa de terminales',
      TERMINAL_COVER_REMOVED_END: 'Fin de remoción de tapa de terminales',
      CURRENT_REVERSAL_L1_START: 'Inicio de inversión de corriente L1',
      CURRENT_REVERSAL_L1_END: 'Fin de inversión de corriente L1',
      MAGNETIC_FIELD_DETECTION_START: 'Inicio de detección de campo magnético',
      MAGNETIC_FIELD_DETECTION_END: 'Fin de detección de campo magnético',
      METER_COVER_OPEN: 'Tapa del medidor abierta',
      METER_COVER_CLOSE: 'Tapa del medidor cerrada',
      METER_AUTHENTICATION_FAILS: 'Falla de autenticación del medidor',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_START:
        'Inicio de presencia de tensión en el lado de la carga',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_END: 'Fin de presencia de tensión en el lado de la carga',
      FIRMWARE_UPGRADE: 'Actualización de firmware',
      DISCONNECT: 'Desconexión',
      CONNECT: 'Conexión',
      CURRENT_REVERSAL_L2_START: 'Inicio de inversión de corriente L2',
      CURRENT_REVERSAL_L2_END: 'Fin de inversión de corriente L2',
      CURRENT_REVERSAL_L3_START: 'Inicio de inversión de corriente L3',
      CURRENT_REVERSAL_L3_END: 'Fin de inversión de corriente L3',
      MISSING_VOLTAGE_L1_START: 'Inicio de ausencia de tensión L1',
      MISSING_VOLTAGE_L1_END: 'Fin de ausencia de tensión L1',
      MISSING_VOLTAGE_L2_START: 'Inicio de ausencia de tensión L2',
      MISSING_VOLTAGE_L2_END: 'Fin de ausencia de tensión L2',
      MISSING_VOLTAGE_L3_START: 'Inicio de ausencia de tensión L3',
      MISSING_VOLTAGE_L3_END: 'Fin de ausencia de tensión L3',
      UNDER_VOLTAGE_L1_START: 'Inicio de subtensión L1',
      UNDER_VOLTAGE_L1_END: 'Fin de subtensión L1',
      UNDER_VOLTAGE_L2_START: 'Inicio de subtensión L2',
      UNDER_VOLTAGE_L2_END: 'Fin de subtensión L2',
      UNDER_VOLTAGE_L3_START: 'Inicio de subtensión L3',
      UNDER_VOLTAGE_L3_END: 'Fin de subtensión L3',
      OVER_VOLTAGE_L1_START: 'Inicio de sobretensión L1',
      OVER_VOLTAGE_L1_END: 'Fin de sobretensión L1',
      OVER_VOLTAGE_L2_START: 'Inicio de sobretensión L2',
      OVER_VOLTAGE_L2_END: 'Fin de sobretensión L2',
      OVER_VOLTAGE_L3_START: 'Inicio de sobretensión L3',
      OVER_VOLTAGE_L3_END: 'Fin de sobretensión L3',
    },
  },
  NetworkManagement: {
    tables: {
      signalQualityTitle: 'Historial de Calidad de Señal',
      commandsPacketsTitle: 'Historial de Paquetes de Comando',
      status: 'Estado del Comando',
      commandType: 'Tipo de Comando',
      lastUpdate: 'Última Actualización',
      serial: 'Serial',
      commandsPackagesHistory: 'Historial de Paquetes de Comando',
      executeNetworkCommands: 'Ejecutar Comandos de Red',
    },
    map: {
      tooltip: 'Leyenda de Señal',
      noSignal: 'Sin Señal',
      poorSignal: 'Muy Débil',
      fairSignal: 'Débil',
      regularSignal: 'Regular',
      goodSignal: 'Bueno',
      excellentSignal: 'Excelente',
    },
    errors: {
      fetchCommandsPackagesHistoryError: 'Error al obtener historial de paquetes de comando',
      fetchSignalQualityHistoryError: 'Error al obtener historial de calidad de señal',
      fetchMetersError: 'Error al obtener medidores',
    },
    general: {
      NoSentPackages: 'Ningún Paquete Enviado para este Comando',
      NoReceivedPackages: 'Ningún Paquete Recibido para este Comando',
      NetworkDetails: 'Detalles de la Red de Medidores',
      DailySignalQualityHistory: 'Calidad de Señal',
      SignalQualityHistory: 'Historial de Señal',
      RssiQualityHistory: 'Historial de RSSI',
      commandsPackagesHistory: 'Historial de Comandos de Red',
    },
  },
  ReadingsTable: {
    serial: 'Serial',
    dateTime: 'Fecha y Hora',
    totalEnergy_Wh: 'Totalizador General (kWh)',
    totalActiveEnergy_Wh: 'Energía Activa Total (kWh)',
    totalDirectActiveEnergy_Wh: 'Energía Activa Directa Total (kWh)',
    borderTotalizer_Wh: 'Totalizador de Punta (kWh)',
    reservedTotalizer_Wh: 'Totalizador de Fora de Punta (kWh)',
    offBorderTotalizer_Wh: 'Totalizador de Reservado (kWh)',
    totalIntermediary_Wh: 'Total Intermedio (kWh)',
    apparentPowerA: 'Potencia Aparente A',
    apparentPowerB: 'Potencia Aparente B',
    apparentPowerC: 'Potencia Aparente C',
    reactivePowerA: 'Potencia Reactiva A',
    reactivePowerB: 'Potencia Reactiva B',
    reactivePowerC: 'Potencia Reactiva C',
    generatedEnergyTotal_Wh: 'Energía Generada - Total (kWh)',
    totalReverseActiveEnergy_Wh: 'Energía Activa Reversa Total (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Energía Generada Fora de Punta (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Energía Generada Intermedio (kWh)',
    generatedBorderEnergyTotal_Wh: 'Energía Generada Punta (kWh)',
    generatedReservedEnergyTotal_Wh: 'Energía Generada Reservada (kWh)',
    q1ReactiveEnergy_VarH: 'Energía Reactiva Q1 (kVarH)',
    q2ReactiveEnergy_VarH: 'Energía Reactiva Q2 (kVarH)',
    q3ReactiveEnergy_VarH: 'Energía Reactiva Q3 (kVarH)',
    q4ReactiveEnergy_VarH: 'Energía Reactiva Q4 (kVarH)',
    reactiveEnergyImportQiRi_VarH: 'Energía Reactiva Import QI (+Ri) (kVarH)',
    reactiveEnergyImportQivRc_VarH: 'Energía Reactiva Import QIV (–Rc) (kVarH)',
    phaseAVoltageAverage_V: 'Tensión Media Fase A (V)',
    phaseBVoltageAverage_V: 'Tensión Media Fase B (V)',
    phaseCVoltageAverage_V: 'Tensión Media Fase C (V)',
    lastAverageVoltageL1_V: 'Media de Tensión L1 (V)',
    lastAverageVoltageL2_V: 'Media de Tensión L2 (V)',
    lastAverageVoltageL3_V: 'Media de Tensión L3 (V)',
    phaseACurrentAverage_A: 'Corriente Media Fase A (A)',
    phaseBCurrentAverage_A: 'Corriente Media Fase B (A)',
    phaseCCurrentAverage_A: 'Corriente Media Fase C (A)',
    lastAverageCurrentL1_A: 'Media de Corriente L1 (A)',
    lastAverageCurrentL2_A: 'Media de Corriente L2 (A)',
    lastAverageCurrentL3_A: 'Media de Corriente L3 (A)',
    totalPowerFactor_NoUnit: 'Factor de Potencia Total',
    phaseAVoltageThd_NoUnit: 'THD Tensión Fase A',
    phaseBVoltageThd_NoUnit: 'THD Tensión Fase B',
    phaseCVoltageThd_NoUnit: 'THD Tensión Fase C',
    phaseACurrentThd_NoUnit: 'THD Corrente Fase A',
    phaseBCurrentThd_NoUnit: 'THD Corrente Fase B',
    phaseCCurrentThd_NoUnit: 'THD Corrente Fase C',
    activePowerThd_NoUnit: 'THD Energia Ativa',
    group0DirectEnergy_Wh: 'Grupo 0 Energía Directa (kWh)',
    group0InductiveReactiveDirectEnergy_VArhPlus: 'Grupo 0 Energía Directa (kVArh+)',
    group0CapacitiveReactiveDirectEnergy_VArhMinus: 'Grupo 0 Energía Directa (kVArh–)',
    group1ReverseEnergy_Wh: 'Grupo 1 Energía Reversa (kWh)',
    group1InductiveReactiveReverseEnergy_VArhPlus: 'Grupo 1 Energía Reversa (kVArh+)',
    group1CapacitiveReactiveReverseEnergy_VArhMinus: 'Grupo 1 Energía Reversa (kVArh–)',
    group2VoltageVaH_V: 'Grupo 2 Tensión Va (V)',
    group2VoltageVbH_V: 'Grupo 2 Tensión Vb (V)',
    group2VoltageVcH_V: 'Grupo 2 Tensión Vc (V)',
    group3CurrentIaH_A: 'Grupo 3 Corrente Ia (A)',
    group3CurrentIbH_A: 'Grupo 3 Corrente Ib (A)',
    group3CurrentIcH_A: 'Grupo 3 Corrente Ic (A)',
    group4ThdVoltageVaH_NoUnit: 'Grupo 4 THD Tensión Va',
    group4ThdVoltageVbH_NoUnit: 'Grupo 4 THD Tensión Vb',
    group4AngleUiA_deg: 'Grupo 4 Ángulo Ui A (º)',
    group4AngleUiB_deg: 'Grupo 4 Ángulo Ui B (º)',
    group4AngleUiC_deg: 'Grupo 4 Ángulo Ui C (º)',
    group4ThdVoltageVcH_NoUnit: 'Grupo 4 THD Tensión Vc',
    group5ThdCurrentIaH_NoUnit: 'Grupo 5 THD Corrente Ia',
    group5ThdCurrentIbH_NoUnit: 'Grupo 5 THD Corrente Ib',
    group5ThdCurrentIcH_NoUnit: 'Grupo 5 THD Corrente Ic',
    totalEnergyIncremental_Wh: 'Totalizador General Incremental (kWh)',
    q1ReactiveEnergyIncremental_VarH: 'Energía Reactiva Q1 Incremental (kVarH)',
    q4ReactiveEnergyIncremental_VarH: 'Energía Reactiva Q4 Incremental (kVarH)',
    voltageA: 'Tensión A (V)',
    voltageB: 'Tensión B (V)',
    voltageC: 'Tensión C (V)',
    currentA: 'Corriente A (A)',
    currentB: 'Corriente B (A)',
    currentC: 'Corriente C (A)',
    activePowerA: 'Potencia Activa A (W)',
    activePowerB: 'Potencia Activa B (W)',
    activePowerC: 'Potencia Activa C (W)',
    maximumVoltageA_V: 'Tensión Máxima A (V)',
    maximumVoltageB_V: 'Tensión Máxima B (V)',
    maximumVoltageC_V: 'Tensión Máxima C (V)',
    minimumVoltageA_V: 'Tensión Mínima A (V)',
    minimumVoltageB_V: 'Tensión Mínima B (V)',
    minimumVoltageC_V: 'Tensión Mínima C (V)',
    maximumCurrentA_A: 'Corriente Máxima A (A)',
    minimumVoltageL1_V: 'Tensión Mínima L1 (V)',
    minimumVoltageL2_V: 'Tensión Mínima L2 (V)',
    minimumVoltageL3_V: 'Tensión Mínima L3 (V)',
    totalInductiveReactiveEnergy_VarH: 'Energía Reactiva Inductiva Total (kVarH)',
    totalCapacitiveReactiveEnergy_VarH: 'Energía Reactiva Capacitiva Total (kVarH)',
    reactiveEnergyImportQiiiRi_VarH: 'Energía Reactiva Import QIII (-Ri) (kVarH)',
    reactiveEnergyImportQiiRc_VarH: 'Energía Reactiva Import QII (+Rc) (kVarH)',
    maximumVoltageL1_V: 'Tensión Máxima L1 (V)',
    maximumVoltageL2_V: 'Tensión Máxima L2 (V)',
    maximumVoltageL3_V: 'Tensión Máxima L3 (V)',
    maximumCurrentL1_A: 'Corrente Máxima L1 (A)',
    maximumCurrentL2_A: 'Corrente Máxima L2 (A)',
    maximumCurrentL3_A: 'Corrente Máxima L3 (A)',
    instantaneousVoltageL1_V: 'Tensión Instantánea L1 (V)',
    instantaneousVoltageL2_V: 'Tensión Instantánea L2 (V)',
    instantaneousVoltageL3_V: 'Tensión Instantánea L3 (V)',
    instantaneousCurrentL1_V: 'Corriente Instantánea L1 (A)',
    instantaneousCurrentL2_V: 'Corriente Instantánea L2 (A)',
    instantaneousCurrentL3_V: 'Corriente Instantánea L3 (A)',
    instantaneousActiveImportPowerAPlusL1: 'Potencia Activa Instantánea Import L1 (W)',
    instantaneousActiveExportPowerAMinusL1: 'Potencia Activa Instantánea Export L1 (W)',
    instantaneousReactiveImportPowerRPlusL1: 'Potencia Reactiva Instantánea Import L1 (VAr)',
    instantaneousReactiveExportPowerRMinusL1: 'Potencia Reactiva Instantánea Export L1 (VAr)',
    totalPowerFactorPhaseA_NoUnit: 'Factor de Potencia Fase A',
    totalPowerFactorPhaseB_NoUnit: 'Factor de Potencia Fase B',
    totalPowerFactorPhaseC_NoUnit: 'Factor de Potencia Fase C',
    inductiveDirectIncremental_VarH: 'Incremental Inductivo Directo (kVarH)',
    capacitiveDirectIncremental_VarH: 'Incremental Capacitivo Directo (kVarH)',
    inductiveReverseIncremental_VarH: 'Incremental Inductivo Reverso (kVarH)',
    capacitiveReverseIncremental_VarH: 'Incremental Capacitivo Reverso (kVarH)',
    directActiveEnergyIncremental_Wh: 'Energía Activa Directa Incremental (kWh)',
    reverseActiveEnergyIncremental_Wh: 'Energía Activa Reversa Incremental (kWh)',
  },
  FrozenData: {
    serial: 'Serial',
    dateTime: 'Fecha y Hora',
    amrProfileStatus: 'Estado del Perfil AMR',
    borderTotalizer_Wh: 'Energía Activa de Pico (kWh)',
    totalEnergy: 'Energía Activa Total (kWh)',
    totalEnergy_Wh: 'Energía Activa Total (kWh)',
    forderTotalizer_Wh: 'Energía Activa Directa T1 (kWh)',
    reservedTotalizer_Wh: 'Energía Activa Reservada (kWh)',
    offBorderTotalizer_Wh: 'Energía Activa Fuera de Punta (kWh)',
    totalIntermediary_Wh: 'Energía Activa Intermedia (kWh)',
    generatedEnergyTotal_Wh: 'Energía Activa Generada (kWh)',
    totalReverseActiveEnergy_Wh: 'Energía Activa Reversa Total (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Energía Activa Generada Fuera de Punta (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Energía Activa Generada Intermedia (kWh)',
    generatedBorderEnergyTotal_Wh: 'Energía Activa Generada de Pico (kWh)',
    generatedReservedEnergyTotal_Wh: 'Energía Activa Generada Reservada (kWh)',
    positiveReactiveEnergy_Wh: 'Energía Reactiva Positiva (kVArh)',
    negativeReactiveEnergy_Wh: 'Energía Reactiva Negativa (kVArh)',
    totalDirectEnergyTariffC_Wh: 'Totalizador de Energía Activa Directa en Tarifa C (kWh)',
    totalDirectEnergyTariffB_Wh: 'Totalizador de Energía Activa Directa en Tarifa B (kWh)',
    totalDirectEnergyTariffA_Wh: 'Totalizador de Energía Activa Directa en Tarifa A (kWh)',
    totalDirectEnergyTariffD_Wh: 'Totalizador de Energía Activa Directa en Tarifa D (kWh)',
    totalReverseEnergyTariffC_Wh: 'Totalizador de Energía Activa Reversa en Tarifa C (kWh)',
    totalReverseEnergyTariffB_Wh: 'Totalizador de Energía Activa Reversa en Tarifa B (kWh)',
    totalReverseEnergyTariffA_Wh: 'Totalizador de Energía Activa Reversa en Tarifa A (kWh)',
    totalReverseEnergyTariffD_Wh: 'Totalizador de Energía Activa Reversa en Tarifa D (kWh)',
    totalInductiveReactiveEnergy_VarH: 'Energía Reactiva Inductiva Total (kVArh)',
    totalCapacitiveReactiveEnergy_VarH: 'Energía Reactiva Capacitiva Total (kVArh)',
    totalInductiveReactiveEnergyTariffC_Wh:
      'Totalizador de Energía Reactiva Inductiva en Tarifa C (kVArh)',
    totalInductiveReactiveEnergyTariffB_Wh:
      'Totalizador de Energía Reactiva Inductiva en Tarifa B (kVArh)',
    totalInductiveReactiveEnergyTariffA_Wh:
      'Totalizador de Energía Reactiva Inductiva en Tarifa A (kVArh)',
    totalInductiveReactiveEnergyTariffD_Wh:
      'Totalizador de Energía Reactiva Inductiva en Tarifa D (kVArh)',
    generatedEnergyTotal: 'Energía Activa Generada Total (kWh)',
    generatedOffBorderEnergyTotal: 'Energía Activa Generada Fuera de Punta (kWh)',
    generatedIntermediaryEnergyTotal: 'Energía Activa Generada Intermedia (kWh)',
    generatedBorderEnergyTotal: 'Energía Activa Generada de Punta (kWh)',
    borderTotalizer: 'Totalizador de Pico',
    reservedTotalizer: 'Totalizador Reservado',
    offBorderTotalizer: 'Totalizador Fuera de Punta',
    totalIntermediary: 'Total Intermedio',
    totalReactiveInductiveEnergy: 'Energía Reactiva Inductiva Total',
    totalReactiveCapacitiveEnergy: 'Energía Reactiva Capacitiva Total',
    consumedMaximunDemand_W: 'Demanda Máxima Consumida (kW)',
    injectedMaximunDemand_W: 'Demanda Máxima Inyectada (kW)',
    reverseCapacitiveReactiveEnergy_VarH: 'Energía Reactiva Capacitiva Reversa (kVarH)',
    reverseInductiveReactiveEnergy_VarH: 'Energía Reactiva Indutiva Reverso (kVarH)',
    cumulativeMaximumDemandRegisterPlusA: 'Demanda Total Acumulada (kW)',
    cumulativeMaximumDemandRegisterMinusA: 'Demanda Total Acumulada Inversa (kW)',
  },
  app: {
    name: 'Sistema de Monitoreo Eléctrico',
    description: 'Panel de control para medición, control e informes de energía',
    language: 'Seleccionar idioma',
  },
  navigation: {
    home: 'Página de Inicio',
    dashboard: 'Dashboard',
    devices: 'Gestionar Dispositivos',
    reports: 'Informes Detallados',
    settings: 'Configuraciones del Sistema',
    logout: 'Salir del Sistema',
    meters: 'Medidores',
    scheduledCommands: {
      label: 'Comandos Programados',
      systemCommands: 'Comandos del Sistema',
      routineListing: 'Listado de Rutinas',
    },
    massCommands: {
      label: 'Comandos en Masa',
      readings: 'Lecturas',
      cutReconnect: 'Corte/Reconexión',
    },
    customReport: 'Informe Personalizado',
    energyBalance: 'Balance Energético',
    smcs: 'SMCs',
    billing: 'Facturación',
    dataExtraction: 'Exportación de datos',
    downloadCenter: 'Centro de Descargas',
    transformers: 'Transformadores',
    areas: 'Áreas',
    regions: 'Regiones',
    serviceNotes: 'Notas de Servicio',
    photocell: 'Fotocélulas',
    mdxWater: 'MDX Agua',
    iagd: {
      label: 'IAGD',
      overview: 'Vista General',
      settings: 'Configuraciones',
      completeness: 'Completitud de Datos',
      ranking: 'Ranking de Sospecha',
    },
    management: {
      label: 'Gestión',
      firmware: 'Firmware',
      gateways: 'Gateways',
      users: 'Usuarios',
      keys: 'Claves',
      tags: 'Etiquetas',
      groups: 'Grupos',
      clients: 'Clientes',
      models: 'Modelos',
      configuration: 'Configuraciones',
    },
  },
  views: {
    iagd: {
      overviewTitle: 'Vista General — IAGD',
      distributor: 'Distribuidora',
      analyzedUcs: 'UCS GD analizadas',
      kpi: {
        totalUcsGd: 'Total UCS GD',
        riskHigh: 'Riesgo Alto',
        riskMedium: 'Riesgo Medio',
        totalFlags: 'Total de Flags',
        metersInRanking: 'Medidores en el ranking',
        percentOfTotal: 'del total',
        accumulatedInPeriod: 'Acumuladas en el período',
      },
      charts: {
        riskDistribution: 'Distribución por Nivel de Riesgo',
        flagComposition: 'Composición de Flags por Tipo',
        scoreDistribution: 'Puntuación Normalizada — Distribución',
        topMeters: 'Top 10 Medidores por Puntuación',
      },
      flagTypes: {
        quedaBrusca: 'Caída Brusca',
        injForaDaJanela: 'Iny. Fuera de Ventana',
        consumoNoturno: 'Consumo Nocturno',
        tensaoIrregular: 'Tensión Irregular',
      },
      riskLevels: {
        alto: 'Alto',
        medio: 'Medio',
        baixo: 'Bajo',
      },
      ranking: {
        title: 'Ranking de Sospecha',
        ucsTag: 'UCs',
        riskLabel: 'Nivel de Riesgo',
        allRisks: 'Todos',
        searchLabel: 'Buscar medidor',
        searchPlaceholder: 'Ej: UC-000001',
        columns: {
          ucId: 'Medidor',
          score: 'Score',
          riskLevel: 'Riesgo',
          quedaBrusca: 'C. Brusca',
          injForaDaJanela: 'Iny. Fuera',
          consumoNoturno: 'C. Nocturno',
          tensaoIrregular: 'Tensión',
          cycle: 'Ciclo',
        },
      },
      rankingModal: {
        titleRisk: 'Nivel de Riesgo — Medidores',
        titleFlag: 'Tipo de Flag — Medidores',
        titleScore: 'Rango de Puntuación — Medidores',
        filterLabelFlag: 'Tipo de Flag',
        filterLabelScore: 'Rango de Puntuación',
      },
      completeness: {
        title: 'Completitud de Datos',
        datePlaceholder: 'Mes/Año',
        dateLabel: 'Período',
        searchLabel: 'Búsqueda por UC ID',
        searchPlaceholder: 'Ej: UC-000001',
        exportCsv: 'Exportar CSV',
        metersTag: 'medidores',
        excludedTag: 'excluidos del análisis',
        legendTitle: 'Leyenda',
        columns: {
          ucId: 'UC ID',
          completeness: 'Completitud',
          excludedReadings: 'Lecturas Ausentes',
          status: 'Estado',
        },
        status: {
          included: 'Incluido',
          attention: 'Atención',
          excluded: 'Excluido',
        },
        cluster: {
          high: 'Alta',
          medium: 'Media',
          low: 'Baja',
        },
        filterStatus: 'Estado',
        filterCluster: 'Rango de Completitud',
        filterAll: 'Todos',
      },
      ucDetail: {
        period: 'Período',
        periodTo: 'hasta',
        chartTitle: 'HISTÓRICO',
        readings: 'LECTURAS (15 MIN)',
        flaggedRegionsLegend: 'Las regiones sombreadas en rojo indican días con alertas activas.',
        anomalyIndicators: 'INDICADORES DE ANOMALÍA',
        flagHistory: 'HISTORIAL DE ALERTAS ACTIVAS',
        tabs: {
          energy: 'Energía (kWh)',
          voltage: 'Tensión (V)',
          current: 'Corriente (A)',
        },
        series: {
          clusterRef: 'Ref. clúster',
          energyDirect: 'Energía Directa',
          energyReverse: 'Energía Inversa',
          movingAverage: 'Media Móvil',
          voltage: 'Tensión',
          current: 'Corriente',
        },
        noData: 'No hay análisis IAGD disponible para esta unidad consumidora.',
      },
      settings: {
        title: 'Configuraciones',
        save: 'Guardar configuraciones',
        saving: 'Guardando...',
        saveSuccess: 'Configuraciones guardadas con éxito',
        saveError: 'Error al guardar configuraciones',
        solarWindow: {
          title: 'Ventana Solar',
          start: 'Inicio',
          end: 'Fin',
          startPlaceholder: 'Ej: 06:00',
          endPlaceholder: 'Ej: 20:00',
        },
        flagThresholds: {
          title: 'Umbrales de Flags',
          abruptDrop: 'Caída Brusca (%)',
          abruptDropHint: 'Caída respecto a la media móvil (default: 40%)',
          nightConsumption: 'Consumo Nocturno Z-score',
          nightConsumptionHint: 'Umbral de desviación estadística (default: 2.5)',
          irregularVoltage: 'Tensión Irregular Z-score',
          irregularVoltageHint: 'Umbral de desviación σ diaria (default: 2.5)',
        },
        pipelineParams: {
          title: 'Parámetros del Pipeline',
          completeness: 'Umbral de Completitud (%)',
          completenessHint: 'Medidores por debajo de este valor son excluidos (default: 70%)',
          clusters: 'Número de Clústeres (K)',
          clustersHint: 'Usado en K-Means de perfil de consumo',
          analysisWindow: 'Ventana de análisis (días)',
        },
        schedules: {
          title: 'Programaciones',
          scoring: 'Cron — Puntuación',
          scoringHint: 'Formato cron. Default: 0 2 * * * (diario, 02h UTC)',
          clustering: 'Cron — Clusterización',
          clusteringHint: 'Default: 0 3 * * 1 (semanal, lun. 03h UTC)',
        },
      },
    },
    downloads: {
      exportStarted: 'Exportación iniciada',
      exportStartedDefault:
        'El archivo estará disponible en la pestaña de descargas tan pronto como finalice el proceso.',
      exportCompleted: 'Archivo disponible',
      exportCompletedDetail: 'El archivo ya está disponible en la Central de Descargas.',
      exportError: 'Error en la exportación',
      exportErrorDefault: 'No se pudo completar la exportación',
      exportDelayed: 'Exportación aún en proceso',
      exportDelayedDetail:
        'La exportación está tardando más de lo esperado. Puede seguir su progreso en la Central de Descargas.',
    },
    massCommands: {
      invalidModel: 'Modelo inválido',
      requiredSerialColumn: 'La columna obligatoria es: Serial',
      invalidDateColumnFormat:
        'La columna Fecha debe estar en el formato: año-mes-día, por ejemplo 2026-01-01.',
    },
    dashboard: {
      title: 'Dashboard',
      tabs: {
        general: 'General',
        commands: 'Comandos',
        alarms: 'Alarmas',
        averageVariation: 'Variación Promedio',
        abruptVariation: 'Variación Abrupta',
        effectivenessAndAvailability: 'Eficiencia y Disponibilidad',
        quality: 'Calidad',
      },
      effectivenessDailyReport: {
        title: 'Informe diario',
        description:
          'Esta descarga genera el informe del día anterior y no utiliza los filtros aplicados abajo.',
        action: 'Descargar informe',
      },
      averageVariation: {
        titleConfigAverageVariation: 'Configuración de Variación Abrupta',
        dailyConsumption: 'Consumo Diario',
        weeklyConsumption: 'Consumo Semanal',
        monthlyConsumption: 'Consumo Mensual',
        events: 'Eventos',
        alarms: 'Alarmas',
        dailySettings: 'Configuraciones de Variación Diaria',
        weeklySettings: 'Configuraciones de Variación Semanal',
        monthlySettings: 'Configuraciones de Variación Mensual',
        weekDay: 'Día de la Semana',
        month: 'Mes',
        weekDays: {
          all: 'Todos',
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
        months: {
          all: 'Todos',
          january: 'Enero',
          february: 'Febrero',
          march: 'Marzo',
          april: 'Abril',
          may: 'Mayo',
          june: 'Junio',
          july: 'Julio',
          august: 'Agosto',
          september: 'Septiembre',
          october: 'Octubre',
          november: 'Noviembre',
          december: 'Diciembre',
        },
        placeholders: {
          selectWeekDay: 'Seleccione el día de la semana',
          selectMonth: 'Seleccione el mes',
          selectEventType: 'Seleccione el tipo de evento',
          loading: 'Cargando...',
          cancel: 'Cancelar',
          save: 'Guardar',
        },
        eventType: 'Tipo de Evento',
        eventTypes: {
          all: 'Todos',
          flow_inversion: 'Inversión de Flujo',
          incomplete_memory: 'Energia Incompleta',
          abrupt_consumption_variation_day: 'Variación Abrupta de Consumo (Día Anterior)',
          abrupt_consumption_variation_week: 'Variación Abrupta de Consumo (Semana Anterior)',
          abrupt_consumption_variation_month: 'Variación Abrupta de Consumo (Mes Anterior)',
          abrupt_generation_variation_day: 'Variación Abrupta de Generación (Día Anterior)',
          abrupt_generation_variation_week: 'Variación Abrupta de Generación (Semana Anterior)',
          abrupt_generation_variation_month: 'Variación Abrupta de Generación (Mes Anterior)',
          last_gasp: 'Last Gasp',
        },
        abruptVariation: 'Variación Abrupta',
        abruptVariationChart: 'Gráfico de Variación Abrupta',
        settings: {
          title: 'Configuración de Variación Abrupta',
          percentageValue: 'Valor de Referencia (%)',
          interval: 'Intervalo',
        },
        search: 'Buscar',
        tableHeaders: {
          startWeek: 'Inicio de la Semana',
          endWeek: 'Fin de la Semana',
          date: 'Fecha',
          weekDay: 'Día de la Semana',
          month: 'Mes',
          serial: 'Serial',
          instalation: 'Instalación',
          installation: 'Instalación',
          consumption: 'Consumo (kWh)',
          generation: 'Generación (kWh)',
          difference: 'Saldo (kWh)',
          startMonth: 'Inicio del Mes',
          endMonth: 'Fin del Mes',
          eventDateTime: 'Fecha/Hora del Evento',
          eventType: 'Tipo de Evento',
        },
      },
    },
    customReport: {
      title: 'Informes',
      emptyState: 'Sin datos para mostrar.',
      readings: 'Lecturas',
      itemsFound: 'elementos encontrados',
      comingSoon: 'Próximamente.',
      transformers: 'Transformadores',
      warnings: {
        invalidPeriodSummary: 'Período inválido',
        invalidPeriodDetail:
          'En la pestaña Variación Abrupta, el período seleccionado debe contener fechas del mismo año. Seleccione fechas dentro del mismo año calendario.',
      },
      events: {
        charts: {
          overload: 'Transformadores en Sobrecarga',
          overvoltage: 'Transformadores en Sobretensión',
          undervoltage: 'Transformadores en Subtensión',
          unbalance: 'Desequilibrio de Tensión',
        },
        tables: {
          overload: 'Sobrecarga',
          overvoltage: 'Sobretensión',
          undervoltage: 'Subtensión',
          unbalance: 'Desequilibrio de Tensión',
        },
        columns: {
          overload: 'Sobrecarga (%)',
          overvoltage: 'Sobretensión (%)',
          undervoltage: 'Subtensión (%)',
          unbalance: 'Desequilibrio (%)',
        },
        viewMore: 'Ver más',
      },
      tabs: {
        general: 'Vista General',
        events: 'Eventos',
        alarms: 'Alarmas',
        loads: 'Cargas',
        abruptVariation: 'Variación Abrupta',
      },
      filters: {
        equipment: 'Distribuidora',
        installation: 'MFINSTALA',
        region: 'Región',
        polygon: 'Polígono',
        load: 'Carga',
        loadRange: '% CARGA',
        cluster: 'Cluster',
        selectPeriod: 'Seleccione el período',
        minPlaceholder: 'Min',
        maxPlaceholder: 'Máx',
        superintendency: 'Supervisión',
        sectional: 'En corte',
        city: 'Ciudad',
        itemsSelected: 'elementos seleccionados',
        equipmentOptions: {
          eqtlMa: 'EQTL-MA',
          eqtlBa: 'EQTL-BA',
          eqtlPi: 'EQTL-PI',
        },
        installationOptions: {
          mfinstala: 'MFINSTALA',
          finstala: 'FINSTALA',
          nfinstala: 'NFINSTALA',
        },
        regionOptions: {
          regional: 'Regional',
          east: 'Este',
          west: 'Oeste',
        },
        polygonOptions: {
          default: 'Polígono',
          centerWest: 'Centro-Oeste',
          coast: 'Litoral',
        },
        loadOptions: {
          default: 'Carga',
          normal: 'Normal',
          overload: 'Sobrecarga',
        },
        clusterOptions: {
          default: 'Cluster',
          upTo100: 'Hasta 100%',
          between100And125: '100% a 125%',
          above175: 'Por encima de 175%',
        },
      },
      legend: {
        normalLoad: 'Carga Normal',
        overload: 'Sobrecarga',
      },
      cards: {
        loadClusters: 'Clusters de Carga',
        overloadByPolygon: 'Sobrecarga por Polígono',
        maxMonthlyLoad: 'Carga Máxima Mensual',
        maxLoad: 'Carga Máxima',
        maxLoadCurve: 'Curva de Carga Máxima',
        maxPhaseUnbalanceCurve: 'Curva de Desbalance de Fase Máximo',
        timeByTier: 'Tiempo por Nivel',
        phaseUnbalanceClusters: 'Clusters de Desbalance de Fase',
      },
      charts: {
        maxLoadCurve: 'Curva de Carga Máxima',
        maxPhaseUnbalanceCurve: 'Curva de Desbalance de Fase Máximo',
        phaseUnbalanceClusters: 'Desbalance de Fase',
      },
      tiers: {
        upTo100: 'hasta 100%',
        between100And125: '100% a 125%',
        between125And150: '125% a 150%',
        between150And175: '150% a 175%',
        above175: 'Por encima de 175%',
      },
      unbalance: {
        upTo10: 'hasta 10%',
        between10And20: '10% a 20%',
        between20And30: '20% a 30%',
        between30And40: '30% a 40%',
        between40And50: '40% a 50%',
        above50: 'por encima de 50%',
      },
      tables: {
        transformer: 'Transformador',
        transformerName: 'Nombre del Transformador',
        loadPercent: '% Carga',
        maxLoad: 'Carga Máx.',
        cluster: 'Cluster',
        phaseUnbalance: 'Desbalance de Fase',
        date: 'Fecha',
        month: 'Mes',
        range: 'Rango',
        total: 'Total',
        percent: 'Porcentaje',
        polygon: 'Polígono',
        region: 'Región',
        normal: 'Normal',
        overload: 'Sobrecarga',
      },
      details: {
        mfinstala: 'MFINSTALA',
        distributor: 'Distribuidora',
        transformer: 'Transformador',
        power: 'Potencia',
        region: 'Región',
        polygon: 'Polígono',
        dataDate: 'Fecha de Datos',
        posto: 'Puesto',
        measurementDate: 'Fecha de Medición',
        imax: 'Imax',
        inum: 'Inum',
        loadPercent: '% Carga',
        loadPercentA: '% Carga A',
        loadPercentB: '% Carga B',
        loadPercentC: '% Carga C',
        clusterPercent: 'Cluster %',
        overload: 'Sobrecarga',
        phaseUnbalance: 'Desbalance de Fase',
        unbalanceCluster: 'Cluster de Desbalance',
        currentA: 'Corriente A',
        currentB: 'Corriente B',
        currentC: 'Corriente C',
        undefined: 'Indefinido',
      },
    },
    process: {
      title: 'Proceso',
      user: 'Usuario Responsable',
      processType: 'Tipo de Proceso',
      updatedAt: 'Última Actualización',
    },
    meters: {
      title: 'Medidores',
      periodUpdateAt: 'Período de última actualización',
      meterInfo: {
        title: 'Detalles del Medidor',
        infoClient: 'Info. Cliente',
        moreDetails: 'Ver Más',
        noInformation: 'Sin información',
        serial: 'Serial',
        installation: 'Instalación',
        displayConfigured: 'Configuración de Display',
        firmware: 'Firmware',
        referenceVoltage: 'Tensión de Referencia',
        accountantStatus: 'Estado de Relé',
        status: 'Estado de Comunicación',
        associatedGateway: 'Gateway asociado:',
        networkTypePublic: 'Pública',
        networkTypePrivate: 'Privada',
        latLong: 'Lat / Long',
        crcMassMemory: 'CRC memoria de masa',
        uplinkPeriod: 'Período de Uplink de Lectura',
        crcFrozenData: 'CRC Energía',
        tags: 'Etiquetas del Medidor',
        regional: 'Regional',
        sectional: 'Seccional',
        polygon: 'Polígono',
        potency: 'Potencia',
        noTags: 'No hay etiquetas encontradas',
        meterModel: {
          manufacturer: 'Fabricante',
        },
        delete: 'Excluir',
        confirmDelete: 'Confirmar exclusión del Medidor',
        confirmDeleteDescription: '¿Estás seguro de querer excluir el Medidor?',
        confirmDeleteText: 'Sí, excluir',
        actions: {
          fileUpload: 'Subir archivo',
          editReadings: 'Edición de Lecturas',
          editTags: 'Configurar Etiquetas',
          searchTags: 'Buscar etiquetas por nombre',
        },
      },
      criticalAlarms: {
        title: 'Alertas Críticas',
        criticalAlarm: 'Alarma crítica',
        readDateTime: 'Horario de Lectura:',
        updatedAt: 'Última Actualización:',
        notFound: '¡No se encontraron alarmas críticas!',
        relayFailure: 'Falla del Relé',
        smiTimeout: 'SMI Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Reconexión local',
        measurementError: 'Error en el sistema de medición',
      },
      maps: {
        title: 'Visualización en el Mapa',
        noLocation: 'No hay ubicación disponible',
      },
      display: {
        title: 'Display del Medidor',
        config: 'Configuraciones del Display',
        save: 'Actualizar configuraciones',
        readDisplay: 'Solicitar lectura del Display',
        '001': 'Día, mes y año actuales',
        '002': 'Hora, minuto y segundos actuales',
        '003': 'Totalizador General Activo',
        '004': 'Totalizador Punta Activo',
        '006': 'Totalizador Reservado Activo',
        '008': 'Totalizador Fuera de Punta Activo',
        '009': 'Totalizador Intermedio Activo',
        '024': 'Totalizador de Energía Reactiva Inductiva',
        '103': 'Totalizador General Reverso',
        '104': 'Totalizador Punta Reverso',
        '106': 'Totalizador Reservado Reverso',
        '108': 'Totalizador Fuera de Punta Reverso',
        '109': 'Totalizador Intermedio Reverso',
      },
      placeholders: {
        serial: 'Ingrese el serial del medidor',
      },
    },
    meterDetails: {
      titleWithSerial: 'Información del medidor - {serial}',
    },
    meterFileUpload: {
      title: 'Carga de archivo',
      meterCardTitle: 'Medidor - {serial}',
      selectPlaceholder: 'Tipo de importación',
      importSpreadsheet: 'Importar planilla',
      cancel: 'Cancelar',
      send: 'Enviar',
      emptyHint: 'Seleccione un tipo e importe la planilla para ver los registros antes del envío.',
      importedRecordsTitle: 'Registros importados',
      qualityWarningTitle: 'Atención',
      qualityWarningDetail:
        'Existen {total} registro(s) sin indicadores de calidad completados. Estos registros pueden ser rechazados durante el procesamiento porque no contienen DRP, DRC, DTT95, FD95 o indicadores por fase.',
      total: 'Total',
      tableEmpty: 'No se encontraron registros.',
      removeDialogTitle: 'Eliminar importación',
      removeDialogMessage: '¿Desea eliminar el archivo y limpiar los datos cargados?',
      remove: 'Eliminar',
      sendDialogTitle: 'Confirmar envío',
      sendDialogMessage: '¿Desea finalizar esta operación y enviar {total} registro(s)?',
      importModalTitle: 'Importar - {label}',
      types: {
        massMemory: 'Memoria de masa',
        quality: 'Parámetros de calidad',
        energy: 'Totalizadores de energía',
        alarms: 'Alarmas',
      },
      toast: {
        importedTitle: 'Archivo importado',
        importedDetail: '{total} registro(s) cargado(s).',
        removedTitle: 'Importación eliminada',
        removedDetail: 'Datos limpiados con éxito.',
        unavailableTitle: 'No disponible',
        alarmsNotImplemented: 'La opción aún no está disponible.',
        sentTitle: 'Envío realizado',
        sentDetail: 'La importación se inició con éxito.',
        sendError: 'No fue posible enviar los datos. Inténtelo de nuevo.',
        noRows: 'No se encontraron registros en el archivo.',
        invalidSerial: 'Número de Serie inválido',
      },
    },
    manualInsertReadings: {
      title: 'Edición de Lecturas/Alarmas manuales',
      tabs: {
        meterAlarms: 'Alarmas Medidores',
        dataReadings: 'Memoria de Masa',
        frozenData: 'Totalizadores',
        qeeIndicators: 'Calidad',
        smcAlarms: 'Alarmas SMCs',
      },
      meterAlarmsTable: {
        serial: 'Serial',
        description: 'Descripción',
        terminal: 'Terminal',
        read: 'Leído',
        manualInsert: 'Es manual',
        installation: 'Instalación',
        user: 'Usuario',
        translate: 'Traducción',
        readDate: 'Fecha de Lectura',
        updatedAt: 'Última Actualización',
      },
      dataReadingsTable: {},
      frozenDataTable: {},
      qeeIndicatorsTable: {
        serial: 'Serial',
        comissioned: 'Comis',
        online: 'Online',
        dateTimeInitial: 'Fecha/Hora Inicial',
        dateTimeFinal: 'Fecha/Hora Final',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        count: 'Conteo',
        meterActivated: 'Medidores Activados',
        drcPhaseA: 'DrcPhaseA',
        drcPhaseB: 'DrcPhaseB',
        drcPhaseC: 'DrcPhaseC',
        drpPhaseA: 'DrpPhaseA',
        drpPhaseB: 'DrpPhaseB',
        drpPhaseC: 'DrpPhaseC',
        consumerUnitsId: 'Unidad Consumidora',
        updatedAt: 'Actualizado en',
      },
      smcAlarmsTable: {
        serial: 'Serial',
        description: 'Descripción',
        read: 'Leído',
        isManualInsert: 'Es manual',
        user: 'Usuario',
        translate: 'Traducción',
        readDateTime: 'Fecha/Hora de Lectura',
        updatedAt: 'Última Actualización',
      },
      messages: {
        qeeEditUnavailable: 'Edición no disponible.',
        qeeClosedCycle: 'El período seleccionado ya fue cerrado y no permite edición manual.',
        invalidDateRange: 'La Fecha/Hora Inicial no puede ser mayor que la Fecha/Hora Final.',
        requiredDrpDrc: 'DRP y DRC son obligatorios.',
        useCommaDecimalSeparator: 'Informe DRP y DRC usando coma y hasta 3 decimales.',
        qeeUpdateSuccess: 'Parámetro actualizado correctamente.',
        qeeUpdateError: 'No fue posible actualizar el parámetro QEE.',
      },
    },
    consumerUnit: {
      fullName: 'Nombre Completo',
      address: 'Dirección',
      locationCode: 'Código de Ubicación',
      consumerUnitCode: 'Código de la Unidad',
      situationCode: 'Código de Situación',
      situationDate: 'Fecha de Situación',
      consumptionClassCode: 'Código de Consumo',
      equipmentNumber: 'Número de Equipo',
      historyUc: 'Histórico',
      communicationDescription: 'Comunicación',
      startRelationDatetime: 'Inicio de la Relación',
      endRelationDatetime: 'Fin de la Relación',
    },
    smcs: {
      title: 'SMCs',
      smcInfo: {
        title: 'Detalles del SMC',
        model: 'Modelo',
        brand: 'Marca',
        serial: 'Serial',
        qtyMeters: 'Cantidad de Clientes',
        uplinkPeriod: 'Período de Uplink de Lectura',
        signalQuality: 'Señal',
        networkPublic: 'Pública ',
        networkPrivate: 'Privada ',
        description: 'Descripción',
        latitude: 'Latitud',
        longitude: 'Longitud',
        tagsFilterTitle: 'Filtros aplicados',
        tagsFilterDetails: 'Filtros por etiquetas aplicados; sin embargo, SMC no tiene etiquetas.',
        doorStatus: 'Estado de la Puerta',
        online: 'Estado de la Comunicación',
        comissioned: 'Comisionado',
      },
      criticalAlarms: {
        title: 'Alertas Críticas',
        criticalAlarm: 'Alarma crítica',
        readDateTime: 'Hora de Lectura:',
        updatedAt: 'Última Actualización:',
        notFound: '¡No se encontraron alarmas críticas!',
        relayFailure: 'Falla del Relé',
        openDoor: 'Puerta Abierta',
        smcTimeout: 'Tiempo de espera del SMC',
        lastGasp: 'Último Gasp',
        localReset: 'Reconexión local',
        measurementError: 'Error en el sistema de medición',
        keysHLSInvalid: 'Claves HLS Inválidas',
        invalidMeter: 'Medidor Inválido',
      },
      success: {
        createSmc: 'SMC creado con éxito',
        updateSmc: 'SMC actualizado con éxito',
      },
      errors: {
        createSmc: 'Error al crear SMC',
        updateSmc: 'Error al actualizar SMC',
        loadSmcModels: 'Error al cargar modelos de SMC',
      },
      summary: {
        statusTitle: 'Estado',
        commissioningTitle: 'Comisionamiento',
        portTitle: 'Estado del puerto',
        fetchErrorTitle: 'Error',
        fetchErrorDetail: 'Error al buscar el resumen de SMCs',
        online: 'En línea',
        offline: 'Fuera de línea',
        absent: 'Ausente',
        commissioned: 'Comisionado',
        notCommissioned: 'No comisionado',
        authorized: 'Autorizado',
        unauthorized: 'Desautorizado',
        details: {
          onlineTitle: 'SMCs en línea',
          offlineTitle: 'SMCs fuera de línea',
          absentTitle: 'SMCs ausentes',
          commissionedTitle: 'SMCs comisionados',
          notCommissionedTitle: 'SMCs no comisionados',
          authorizedTitle: 'SMCs con estado del puerto autorizado',
          unauthorizedTitle: 'SMCs con estado del puerto desautorizado',
          selectBrand: 'Seleccione la marca',
        },
      },
      registerSmcFile: 'Importar SMCs desde archivo',
      editSmcFile: 'Editar SMCs desde archivo',
      massActionStartedTitle: 'Proceso iniciado',
      massActionStartedDetail: 'Proceso iniciado. Espere a que finalice la acción.',
    },
    modemInfo: {
      title: 'Módem',
      notAvailable: 'No disponible',
      noInformation: 'Sin información',
      deviceEui: 'EUI',
      firmwareVersion: 'Firmware',
      signal: 'Señal',
      iccid: 'ICCID',
      imei: 'IMEI',
      imsi: 'IMSI',
      operator: 'Operadora',
      cellId: 'Cell ID',
      signalQuality: 'Señal',
      bootCounter: 'Boot Counter',
      snr: 'SNR',
      rssi: 'RSSI',
      bleStack: 'BleStack',
      mcuRevision: 'Revisión MCU',
    },
    commands: {
      title: 'Comandos',
      command: 'Comando',
      notAvailable: 'No disponible',
      state: 'Estado',
      commandQueue: 'Comandos en Cola',
      noCommand: 'Sin Comando en Cola',
      lastSeen: 'Última Comunicación',
      communication: 'Comunicación',
      noCommunication: 'No disponible',
      lastCommand: 'Último Comando',
      sendCommand: 'Enviar',
      notImplemented: 'Comando no implementado',
      voltageOutIntervalMinites: 'Minuto(s)',
      voltageOutIntervalHours: 'Hora(s)',
      voltageOutIntervalDays: 'Día(s)',
      sendToSelected: 'Enviar a Seleccionados',
      sendToAll: 'Enviar a todos',
      listOfCommands: {
        setSmiVoltageOutInterval: 'Definir Intervalo DIC/FIC',
        setSmiQueeInterval: 'Definir Intervalo DRP/DRC',
        setTariff: 'Definir Tipo de Tarifa',
        updateDateTime: 'Actualizar Fecha y Hora',
        readDateTime: 'Leer Fecha y Hora',
        updatePeriod: 'Cambiar Período',
        getRelay: 'Obtener estado del relé',
        setRelayOff: 'Desconectar Relé',
        setRelayOn: 'Conectar Relé',
        setReferenceVoltage: 'Tensión de Referencia',
        getReferenceVoltage: 'Obtener Tensión de Referencia',
        recoverActiveEnergy: 'Solicitar Energías',
        getNetworkType: 'Obtener Tipo de Red',
        setNetworkPublic: 'Cambiar a red pública',
        setNetworkPrivate: 'Cambiar a red privada',
        getTech: 'Obtener Tecnología',
        setNetworkCatm1: 'Cambiar a CATM1',
        setNetworkNbiot: 'Cambiar a NBIoT',
        getCellIdAndIP: 'Obtener Cell ID e IP',
        setEventQeeIndicator: 'Recuperar Parámetros de Calidad',
        setStandartFrozenData: 'Definir Energías Estándar',
        setDisplayAuto: 'Configurar Display Automático',
        setDisplayManual: 'Configurar Display Manual',
        setDisplayAutoMicroMax: 'Configurar Display Automático MicroMax',
        setDisplayManualMicroMax: 'Configurar Display Manual MicroMax',
        recoverShortDurationAlarms: 'Recuperar Alarmas de Corta Duración',
        getFiscalPage: 'Recuperar Página Fiscal',
        getLoadProfile: 'Recuperar Perfil de Carga',
        getDailyBilling: 'Recuperar Facturación Diaria',
        updateDatetimeSmc: 'Actualizar Fecha/Hora (SMC)',
        updateDatetimeSmi: 'Actualizar Fecha/Hora (SMI)',
        instantMeasureSmc: 'Lectura Instantánea SMC',
        instantMeasureSmi: 'Lectura Instantánea',
        requestInstantMeasures: 'Solicitar mediciones instantáneas',
        nicResetSmi: 'Reiniciar NIC SMI',
        nicResetSmc: 'Reiniciar NIC SMC',
        recoverMassMemorySmc: 'Recuperar Memoria de Masa (SMC)',
        recoverMassMemorySmi: 'Recuperar Memoria de Masa (SMI)',
        recoverEnergySmc: 'Recuperar Energía SMC',
        recoverEnergySmi: 'Recuperar Energía',
        recoverQeeIndicator: 'Recuperar Indicador QEE',
        requestRelayStatusAllSmc: 'Obtener estado del relé SMC',
        requestDoorStatus: 'Obtener Estado de la Puerta',
        getVoltageOutLong: 'Obtener Alarma de Interrupción Larga',
        getVoltageOutShort: 'Obtener Alarma de Interrupción Corta',
        setStandardFrozenData: 'Configurar Plantilla de Energía Estándar',
        getQeeTransparent: 'Obtener Transparencia',
        readDisplayConfiguration: 'Leer Configuración del Display',
        setDisplayConfiguration: 'Configurar Display',
        voltageInterruptionMonthly: 'Obtener Interrupción de Tensión Mensual',
        drpDrcMonthly: 'Obtener DRP/DRC Mensual',
        drpDrcCycle: 'Obtener Ciclo DRP/DRC',
        nicReset: 'Reset de la NIC',
        monitoring: 'Perfil de Carga (Energía + Memoria)',
        deviceReset: 'Reiniciar Dispositivo',
        infoRequest: 'Solicitar información general',
        requestConfiguration: 'Solicitar configuración',
        getBlockSize: 'Obtener Tamaño del Bloque',
        imageTransferInitiate: 'Iniciar Transferencia de Imagen',
        imageTransferData: 'Datos de Transferencia de Imagen',
        getFirstBlockNotTransferred: 'Obtener Primer Bloque No Transferido',
        imageTransferVerify: 'Verificar Transferencia de Imagen',
        imageTransferActivate: 'Activar Transferencia de Imagen',
        updateFirmware: 'Actualizar Firmware',
        uploadFirmware: 'Cargar Firmware',
        getHardwareInfo: 'Obtener Información de Hardware',
        readNicInfo: 'Esperando',
        readNicSetup: 'Esperando',
        readRelay: 'Esperando',
        readTimestamp: 'Esperando',
        readNicData: 'Esperando',
        nicSetup: 'Esperando',
        readLdrUpper: 'Esperando',
        readLdrBottom: 'Esperando',
        readLdrMin: 'Esperando',
        setLdrUpper: 'Esperando',
        setLdrBottom: 'Esperando',
        setLdrMin: 'Esperando',
        readNicSerial: 'Esperando',
        readRelayWithLastSwitchOn: 'Esperando',
        readRelayWithLastSwitchOnAndOff: 'Esperando',
        setBlockSize: 'Esperando',
        multicastGroupSetup: 'Esperando',
        multicastClassCSession: 'Esperando',
        multicastSetupConfirmation: 'Esperando',
        imageTransferStatus: 'Esperando',
        getFirmwareVersion: 'Esperando',
        readAlarmFakeOnOff: 'Esperando',
        configureApplicationGroup: 'Esperando',
        readALarmLastGasp: 'Esperando',
        setLastGaspVoltageLevel: 'Esperando',
        readAlarmVoltageMonitor: 'Esperando',
        setVoltageMinimalInterval: 'Esperando',
        setAlarmFakeOnOffThreshold: 'Esperando',
        readTemperatureValue: 'Esperando',
        readRelayWithDelay: 'Esperando',
        deviceCreated: 'Dispositivo creado',
        deviceUpdated: 'Dispositivo actualizado',
        scheduleCreated: 'Programación creada',
        scheduleUpdated: 'Programación actualizada',
        groupCreated: 'Grupo creado',
        groupUpdated: 'Grupo actualizado',
        setAlarmFakeOnOff: 'Alarma On/Off',
        scheduleCanceled: 'Programación cancelada',
        scheduleDeleted: 'Programación eliminada',
        deviceDeleted: 'Dispositivo eliminado',
        groupDeleted: 'Grupo eliminado',
        checkScheduleStatus: 'Verificar estado de la programación',
        activateSchedule: 'Activar programación',
        deactivateSchedule: 'Desactivar programación',
        checkScheduleExist: 'Verificar si existe la programación',
        readDeviceType: 'Leer tipo de dispositivo',
        writeDeviceRole: 'Asignar tipo de dispositivo',
        fullScheduleCommand: 'Comando de programación completo',
        scheduleCreatedOnSystem: 'Programación creada (Sistema)',
        activateScheduleOnSystem: 'Activar programación (Sistema)',
        checkScheduleStatusOnSystem: 'Verificar estado de la programación (Sistema)',
        writeDeviceRoleOnSystem: 'Asignar tipos de dispositivo (Sistema)',
        deactivateScheduleOnSystem: 'Desactivar programación (Sistema)',
        checkScheduleExistOnSystem: 'Verificar si existe la programación (Sistema)',
        readDeviceTypeOnSystem: 'Leer tipo de dispositivo (Sistema)',
        setDatetimeOnSystem: 'Actualizar Fecha y Hora (Sistema)',
        periodicConfiguration: 'Configuración de Periodicidad',
        decommissioning: 'Desmantelamiento',
        openSession: 'Abrir Sesión con Medidor',
        readMeterSerial: 'Leer Serial del Medidor',
        importMassMeters: 'Importar medidores en masa',
        saveConfig: 'Guardar configuración',
        readConfig: 'Leer configuración',
        saveTime: 'Guardar fecha y hora',
        timeCorrection: 'Corrección de hora',
        storage: 'Almacenamiento',
        fuotaPause: 'Pausa de actualización de firmware',
        deleteSpecialDays: 'Eliminar días festivos',
        getTotalizers: 'Leer totalizadores',
        getRelayStatusControl: 'Leer Estado de Control del Relé',
        setRelayStatusControl: 'Cambiar Estado de Control del Relé',
        getIntegrationInstantaneousReadings: 'Leer valores instantáneos',
        getVoltageOutLongShort: 'Obtener Alarma de Voltage Out Larga y corta',
        relayStatusOrca: 'Recuperar estado del relé orca',
        getQeeOnDemand: 'Solicitar parámetros de calidad por demanda',
        getQeeHistoricalData:
          'Solicitar el historial de lectura de datos de los parámetros de calidad',
        recoverFragmentedPacket: 'Recuperar datos fragmentados',
        drpDrcEventLog: 'Registro de eventos DRP y DRC',
        readTariffPeriods: 'Obtener Lectura de Tarifa',
        smartFuseAlarmAck: 'Alarma Ack',
        getCollectiveCutStatus: 'Obtener Estado de corte colectivo',
        sendRollback: 'Enviar RollBack',
        disableCollectiveCut: 'Autorizar Apertura de Puertas',
        enableCollectiveCut: 'Desactivar Apertura de Puerta',
        relayOnAllMeterSmc: 'Reconectar Todos los Clientes',
        getStatus: 'Obtener Estado del Relé',
        activate: 'Activar Relé',
        disable: 'Desactivar Relé',
        requestMeters: 'Requisitar Medidores',
        getTariffReading: 'Obtener Tipo de Tarifa',
      },
      placeholders: {
        selectCommand: 'Seleccione un comando',
        sendToSelected: 'Enviar a Seleccionados',
      },
      messagesSuccess: {
        success: 'Éxito',
        commandSent: '¡Comando enviado con éxito!',
        commandExecuted: '¡Comando ejecutado con éxito!',
      },
      messagesErrors: {
        error: 'Erro',
        commandSent: 'Error al enviar comando',
        commandExecuted: 'Error al ejecutar comando',
        errorVerifyCommandCondition: 'Error al verificar condición del comando',
        errorFilterCommands: 'Error al filtrar comandos disponibles',
        commandExecutedTryAgain:
          'No fue posible ejecutar el comando.\nIntente nuevamente más tarde.',
        commandExecutedPartial: 'Los comandos fueron ejecutados parcialmente.',
        commandExecutedPartialNotExecute: ' no ejecutaron.',
      },
    },
    dataExtraction: {
      title: 'Exportación de datos',
      cardTitle: 'Extracción masiva de datos',
      dateRangePlaceholder: 'Seleccione el período',
      dateRangeTooltip: 'Informe un período de como máximo 30 días',
      selectPlaceholder: 'Tipo de exportación',
      consult: 'Consultar',
      serialLabel: 'Serial',
      serialsPlaceholder:
        'Ingrese un serial por línea o separados por coma, espacio o punto y coma. Este campo es opcional. Puede ajustar la información que desea extraer según los filtros informados. Solo el tipo de exportación y el período son obligatorios; serial y cliente son opcionales.',
      serialsHint: 'Total de seriales válidos: {total}',
      previewTitle: 'Previsualización de registros',
      tableEmpty: 'No se encontraron registros',
      noResults: 'No se encontraron registros para los filtros informados.',
      previewError: 'Error al consultar los datos para exportación.',
      maxRangeExceededError: 'El intervalo informado debe ser de como máximo 30 días.',
      maxRangeFutureDateError: 'La fecha final no puede ser mayor que la fecha de hoy.',
      filter: {
        typeLabel: 'Tipo de exportación',
        periodLabel: 'Período',
        clientLabel: 'Cliente',
        clientPlaceholder: 'Seleccione un cliente',
        validationMessage:
          'Indique el tipo de exportación y el período. El serial y el cliente son opcionales.',
      },
      types: {
        massMemory: 'Memoria de masa',
        energy: 'Energía',
        alarms: 'Alarmas',
        latestQualityParameters: 'Parámetros de calidad más recientes',
        qualityDicFic: 'Parámetros de calidad - DIC/FIC',
        qualityDrpDrc: 'Parámetros de calidad - DRP/DRC',
      },
      clearFiltersDialog: {
        title: 'Limpiar filtros',
        message: '¿Realmente desea limpiar los filtros y la vista previa de los datos?',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      summary: {
        warning: 'Atención',
        info: 'Información',
        success: 'Éxito',
        error: 'Error',
      },
    },
    firmware: {
      title: 'Versión de Firmware',
      version: 'Versión de Firmware',
      registerFirmware: 'Nueva Versión',
      editFirmware: 'Editar firmware',
      registerFirmwareFile: 'Importar firmwares desde archivo',
      editFirmwareFile: 'Editar firmwares desde archivo',
      success: {
        getFirmwares: 'Firmwares buscados con éxito',
      },
      errors: {
        getFirmwares: 'Error al buscar firmwares',
      },
    },
    keys: {
      title: 'Claves',
      importKeys: 'Importar Claves',
      editKeysInBulk: 'Editar Claves en Masa',
      registerKeysInBulk: 'Registrar Claves en Masa',
      periodPlaceholder: 'Seleccione el período',
      success: {
        getKeys: 'Claves buscadas con éxito',
        createKey: 'Clave registrada con éxito',
        updateKey: 'Clave actualizada con éxito',
        addMassKeys: 'Solicitud de registro de claves enviada',
      },
      errors: {
        getKeys: 'Error al buscar claves',
        createKey: 'Error al registrar clave',
        updateKey: 'Error al actualizar clave',
        addMassKeys: 'Error al enviar comando',
        convertKey: 'Error al convertir clave a hexadecimal',
      },
      toasts: {
        importSuccess: 'Importación completada con éxito',
        importSuccessDetail: 'Todas las claves han sido importadas con éxito',
        importPartial: 'Importación parcialmente completada',
        importPartialDetail: 'clave importada con éxito, | claves importadas con éxito,',
        importError: 'Error al importar claves',
        editSuccess: 'Edición completada con éxito',
        editSuccessDetail: 'Todas las claves han sido editadas con éxito',
        editPartial: 'Edición parcialmente completada',
        editPartialDetail: 'clave editada con éxito, | claves editadas con éxito,',
        editError: 'Error al editar claves',
        failed: 'falló | fallaron',
      },
    },
    tags: {
      title: 'Etiquetas',
      newTag: 'Nueva Etiqueta',
      success: {
        getTags: 'Etiquetas buscadas con éxito',
        createTag: 'Etiqueta creada con éxito',
        updateTag: 'Etiqueta actualizada con éxito',
        deleteTag: 'Etiqueta eliminada con éxito',
      },
      errors: {
        getTags: 'Error al buscar etiquetas',
        createTag: 'Error al crear etiqueta',
        updateTag: 'Error al actualizar etiqueta',
        deleteTag: 'Error al eliminar etiqueta',
      },
    },
    clients: {
      client: 'Cliente',
      clients: 'Clientes',
      clientDetails: 'Detalles del Cliente',
      editClient: 'Editar Cliente',
      fullName: 'Nombre Completo',
      location: 'Ubicación',
      updatedAt: 'Actualizado en',
      metersTableTitle: 'Medidores del Cliente',
      addMeters: 'Agregar Medidores',
      removeMeters: 'Eliminar Medidores',
      removeMetersDescription:
        '¿Está seguro que desea eliminar los medidores seleccionados de este cliente?',
      confirmRemoveMeters: 'Si, eliminar',
      weights: 'Pesos',
      prefixUf: 'Prefijo UF',
    },
    balance: {
      title: 'Balance',
      balanceCalculation: 'Cálculo de Balance',
      balanceSettings: 'Configuraciones del Balance',
      publicLighting: 'Iluminación Pública - IP (kWh)',
      search: 'Buscar',
      balanceEnergy: 'Balance Energético',
      balanceEnergyChart: 'Gráfico de Balance Energético',
      data: 'Fecha',
      meterTrafo: 'Medidor del Trafo',
      energyRequired: 'Energía Requerida (kWh)',
      energyConsumed: 'Energía Consumida (kWh)',
      energyPublicLightingLabel: 'Iluminación Pública',
      loss: 'Pérdida (kWh)',
      lossPercentage: 'Pérdida %',
      energyPublicLighting: 'Energía IP (kWh)',
      readingDateTime: 'Fecha de Lectura',
      initialReadingDateTime: 'Fecha de Lectura Inicial',
      finalReadingDateTime: 'Fecha de Lectura Final',
      energyInjectedConsumers: 'Energía Inyectada a los Consumidores (kWh)',
      energyReverseTransformer: 'Energía Reversa del Trafo (kWh)',
      empty: 'Vacío por ahora...',
      results: 'Resultado',
      transformerName: 'Nombre del Trafo',
      areaName: 'Nombre del Área',
      regionName: 'Nombre de la Región',
      placeholders: {
        publicLighting: 'Ingrese el valor',
      },
      errors: {
        loadBalance: 'Error al buscar balance',
      },
    },
    transformers: {
      title: 'Transformadores',
      transformer: 'Transformador',
      startDate: 'Fecha inicial',
      endDate: 'Fecha final',
      placeholders: {
        loading: 'Cargando...',
        select: 'Elegir Transformador',
        selectDate: 'Seleccione la fecha',
      },
      errors: {
        title: 'Error',
        loadTransformers: 'Error al cargar transformadores',
      },
    },
    groupDetails: {
      monthlyQualityParameters: {
        title: 'Promedio mensual de DRP/DRC',
        button: 'Calcular promedio mensual de DRP/DRC',
        dialogTitle: 'Promedio mensual de DRP/DRC',
        success: 'Promedio mensual de DRP/DRC calculado correctamente',
        error: 'Error al calcular el promedio mensual de DRP/DRC',
        exportError: 'Seleccione una referencia para exportar el promedio mensual de DRP/DRC.',
      },
      latestQualityParameters: {
        title: 'Parámetros de calidad más recientes',
        error: 'Error al cargar los parámetros de calidad más recientes',
      },
    },
    scheduledCommands: {
      title: 'Listado de Rutinas',
      filterByGroup: 'Filtrar por nombre del Grupo',
      statusChanged: 'Estado de la programación cambiado',
      deleteSuccess: 'Programación eliminada correctamente',
      timeMax: 'Tiempo máximo para ejecutar el comando',
      description: 'Descripción',
      selectGroup: 'Seleccionar grupo',
      selectCommand: 'Seleccionar comando',
      editRoutine: 'Editar Rutina',
      addRoutine: 'Agregar Rutina',
      configure: 'Configurar',
      review: 'Revisar',
      quantityLastMeasures: 'Cantidad de Últimas Mediciones',
      quantityLastMeasuresSmc: 'Cantidad de Últimas Mediciones (SMC)',
      commandParameters: 'Parámetros del Comando',
      alternativeDataSmi: 'Datos Alternativos (SMI)',
      energyRecoveryDataSmi: 'Datos de Recuperación de Energía (SMI)',
      initialDateTime: 'Fecha/Hora Inicial',
      finalDateTime: 'Fecha/Hora Final',
      intervalMinutes: 'Intervalo en Minutos',
      seconds: 'Segundos',
      back: 'Volver',
      update: 'Actualizar',
      add: 'Agregar',
      routineUpdated: 'Rutina Actualizada',
      routineCreated: 'Rutina Creada',
      saveRoutineError: 'Error al guardar Rutina',
      unknownError: 'Error desconocido',
      loadGroupsError: 'Error al buscar grupos',
      successTitle: 'Éxito',
      errorTitle: 'Error',
      statusChangeError: 'Error al cambiar el estado de la programación',
      deleteRoutineError: 'Error al eliminar la programación',
      minuteUnit: 'minuto',
      minutesUnit: 'minutos',
      placeholders: {
        filterByGroup: 'Ingrese el nombre del Grupo',
        description: 'Ingrese una descripción para la rutina',
        selectGroup: 'Seleccione un grupo',
        selectCommand: 'Seleccione un comando',
        quantity: 'Ingrese la cantidad',
        initialDate: 'Seleccione la fecha inicial',
        finalDate: 'Seleccione la fecha final',
        interval: 'Ingrese el intervalo',
        secondsQuantity: 'Ingrese la cantidad de segundos',
      },
      days: 'Día(s)',
      hours: 'Hora(s)',
      minutes: 'Minuto(s)',
      cronEditor: 'Editor Cron',
      validation: {
        descriptionRequired: 'Ingrese la descripción de la rutina.',
        descriptionHtmlNotAllowed: 'La descripción de la rutina no puede contener HTML.',
        groupRequired: 'Seleccione un grupo.',
        minimumDuration: 'El tiempo máximo para ejecutar el comando debe ser de al menos 1 minuto.',
        invalidCron: 'Configure un cron válido para la rutina.',
      },
      cronEditorOptions: {
        intlLocale: 'es-ES',
        every: 'Todo(a)',
        second: 'Segundo',
        minute: 'Minuto',
        hour: 'Hora',
        day: 'Día',
        week: 'Semana',
        month: 'Mes',
        year: 'Año',
        everySecond: 'cada segundo',
        everyMinute: 'cada minuto',
        everyHour: 'cada hora',
        everyMonth: 'cada mes',
        everyDayOfWeek: 'cada día específico de la semana',
        noSpecificDay: 'sin día específico',
        noSpecificDayOfWeek: 'sin día específico de la semana',
        all: 'todos',
        of: 'de',
        onDays: 'en el/los día(s)',
        and: 'y',
        andOf: 'y de',
        at: 'a las',
        secondsSuffix: 'segundo(s)',
      },
      nextExecution: 'Próxima ejecución',
      lastExecution: 'Última ejecución',
      routineDetails: 'Detalles de la Rutina',
      routinePage: 'Página de la Rutina',
      deleteRoutine: 'Eliminar Rutina',
      noProcessYet: 'No se encontró ningún proceso para esta rutina hasta el momento.',
    },
    transformerDetails: {
      title: 'Detalles del Transformador',
      details: 'Detalles',
      transformer: 'Transformador',
      editTransformer: 'Editar Transformador',
      name: 'Nombre',
      meterSerial: 'Serial del Medidor',
      metersCount: 'Cantidad de Medidores',
      publicLighting: 'Iluminación Pública',
      coordinates: 'Coordenadas',
      updatedAt: 'Última Actualización',
      description: 'Descripción',
      viewMore: 'Ver Más',
      meterDetails: 'Medidor del Transformador',
      manufacturerType: 'Fabricante | Tipo',
      serial: 'Serial',
      installation: 'Instalación',
      displayConfiguration: 'Configuración de Display',
      firmware: 'Firmware',
      relayStatus: 'Estado de Relé',
      status: 'Estado',
      meterMoreDetails: 'Detalles del Medidor',
      latitude: 'Lat',
      longitude: 'Long',
      massMemoryCrc: 'CRC Memoria de Masa',
      uplinkPeriod: 'Período de Uplink de Lectura',
      energyCrc: 'CRC Energía',
      tags: 'Etiquetas del Medidor',
      noTags: 'No hay etiquetas encontradas',
      close: 'Cerrar',
      loading: 'Cargando...',
    },
    areas: {
      title: 'Áreas',
      startDate: 'Fecha inicial',
      endDate: 'Fecha final',
      search: 'Buscar',
      placeholders: {
        loading: 'Cargando...',
        select: 'Elegir Área',
        selectDate: 'Seleccione la fecha',
      },
      errors: {
        title: 'Error',
        loadAreas: 'Error al cargar áreas',
      },
    },
    areaDetails: {
      title: 'Detalles de la Área',
      details: 'Detalles',
      area: 'Área',
      editArea: 'Editar Área',
      name: 'Nombre',
      transformersCount: 'Cantidad de Transformadores',
      updatedAt: 'Última Actualización',
      description: 'Descripción',
      errors: {
        title: 'Error',
        loadAreaInfo: 'Error al buscar información de la área',
      },
    },
    regions: {
      title: 'Regiones',
      regions: 'Regiones',
      selectPeriod: 'Seleccione el período',
      startDate: 'Fecha inicial',
      endDate: 'Fecha final',
      search: 'Buscar',
      placeholders: {
        loading: 'Cargando...',
        select: 'Elegir Región',
        selectDate: 'Seleccione la fecha',
      },
      errors: {
        title: 'Error',
        loadRegions: 'Error al cargar regiones',
      },
    },
    regionDetails: {
      title: 'Detalles de la Región',
      details: 'Detalles',
      region: 'Región',
      editRegion: 'Editar Región',
      name: 'Nombre',
      areasCount: 'Cantidad de Áreas',
      updatedAt: 'Última Actualización',
      description: 'Descripción',
      errors: {
        title: 'Error',
        loadRegionInfo: 'Error al buscar información de la región',
      },
    },
    serviceNotes: {
      code: 'Código',
      contractAccount: 'Cuenta de Contrato',
      dateTimeLimitConclusion: 'Fecha Límite de Finalización',
      dateTimeStart: 'Fecha de Inicio',
      codeGroup: 'Grupo de Código',
      installation: 'Instalación',
      measureCodeGroup: 'Grupo de Código de Medición',
      noteNumber: 'Número de Nota',
      equipmentSerialNumber: 'Número de Serie del Equipo',
      cancellationRequest: 'Solicitud de Cancelación',
      noteType: 'Tipo de Nota',
      cPNumber: 'Número CP',
      cSNumber: 'Número CS',
      cSPosition: 'Posición CS',
      noteGroup: 'Grupo de Notas',
      noteCode: 'Código de Nota',
      measureGroup: 'Grupo de Medición',
      equipment: 'Equipo',
      referenceMonth: 'Mes de Referencia',
      creationDate: 'Fecha de Creación',
      creationHour: 'Hora de Creación',
      limitDate: 'Fecha Límite',
      limitHour: 'Hora Límite',
      serialMeter: 'Número de Serie del Medidor',
      rateType: 'Tipo de Tarifa',
      ssn: 'SSN',
      min: 'MIN',
      readingDate: 'Fecha de Lectura',
      readingUnit: 'Unidad de Lectura',
      day: 'Día',
      serial: 'Serial',
      registers: 'Registros',
      attempts: 'Intentos',
      origin: 'Origen',
      datetime: 'Fecha',
      online: 'Estado',
      meterActivated: 'Estado del Relé',
      comissioned: 'Comisionado',
      dateTimeInitial: 'Fecha de Inicio',
      dateTimeFinal: 'Fecha de Finalización',
      drp: 'DRP',
      drc: 'DRC',
      updatedAt: 'Actualizado en',
      count: 'Conteo',
      description: 'Descripción',
    },
    models: {
      title: 'Modelos',
      meterModels: 'Modelos de Medidores',
      smcModels: 'Modelos de SMCs',
      newModel: 'Nuevo Modelo',
      registerModelFile: 'Importar modelos por archivo',
      editModelFile: 'Editar modelos por archivo',
      import: {
        successAll: 'Importación realizada con éxito',
        partial: 'Importación parcialmente completada',
        error: 'Error al importar modelos',
      },
      edit: {
        successAll: 'Edición realizada con éxito',
        partial: 'Edición parcialmente completada',
        error: 'Error al editar modelos',
      },
      success: {
        createModel: 'Modelo creado con éxito',
        updateModel: 'Modelo actualizado con éxito',
      },
      errors: {
        title: 'Error',
        loadModels: 'Error al buscar modelos',
        noModelSelected: 'Ningún modelo seleccionado',
        manufacturerNotFound: 'Fabricante no encontrado',
        createModel: 'Error al crear modelo',
        updateModel: 'Error al actualizar modelo',
      },
    },
    configuration: {
      title: 'Configuraciones',
      configure: 'Configurar',
      effectiveness: {
        title: 'Efectividad',
        description: 'Configure la cantidad mínima de medidores para el cálculo de efectividad.',
        dialog: {
          title: 'Configuración de Efectividad',
          minimumQuantity: 'Cantidad Mínima',
          loading: 'Cargando...',
          cancel: 'Cancelar',
          save: 'Guardar',
        },
      },
      abruptVariation: {
        title: 'Variación Abrupta',
        description: 'Configure los parámetros de detección de variación abrupta de consumo.',
      },
    },
  },
  auth: {
    login: {
      title: 'Acceso al Sistema',
      emailLabel: 'Correo electrónico',
      associate: 'Asociado',
      associateWarn:
        'Hemos verificado que aún no tienes vínculo en el sistema. Por favor, agrega tu correo electrónico.',
      passwordLabel: 'Contraseña',
      submitButton: 'Ingresar localmente',
      submitButtonAd: 'Iniciar sesión Active Directory',
      forgotPassword: '¿La contraseña expiró?',
      placeholders: {
        email: 'Ingrese su correo electrónico',
        password: 'Ingrese su contraseña',
      },
      validation: {
        invalidEmail: 'Correo electrónico inválido',
        adCredentialRequired: 'El usuario de red o correo electrónico es obligatorio',
        passwordRequired: 'La contraseña es obligatoria',
      },
    },
    userType: {
      admin: 'Administrador',
      operator: 'Operador Técnico',
      user: 'Usuário',
      erector: 'Instalador',
      manager: 'Gestor Técnico',
      sap: 'Usuário SAP',
      monitor: 'Monitor',
      invalid: 'Inválido',
    },
    errors: {
      invalidCredentials: 'Correo electrónico o contraseña inválidos',
      missingFields: 'Todos los campos deben ser completados',
    },
    requiredChangePassword: {
      title: 'Cambio de Contraseña Obligatorio',
      emailLabel: 'Correo electrónico',
      expiredPasswordLabel: 'Contraseña actual',
      newPasswordLabel: 'Nueva contraseña',
      submitButton: 'Cambiar Contraseña',
      instructions: 'Cambie la contraseña creada por el administrador.',
      passwordRequirements:
        'La contraseña debe contener al menos 8 caracteres, una letra mayúscula, una letra minúscula, un número y un carácter especial.',
      placeholders: {
        email: 'Ingrese su correo electrónico',
        expiredPassword: 'Ingrese la contraseña actual',
        newPassword: 'Ingrese su nueva contraseña',
      },
      messages: {
        successSummary: 'Contraseña Cambiada Exitosamente',
        successDetail: 'La próxima vez, inicie sesión con su email y nueva contraseña',
        errorSummary: 'Error',
        errorDetail: 'Error al cambiar contraseña',
      },
      validation: {
        emailRequired: 'El correo electrónico es obligatorio',
        expiredPasswordRequired: 'La contraseña actual es obligatoria',
        newPasswordMinLength: 'La contraseña debe tener al menos 8 caracteres',
        newPasswordUppercase: 'La contraseña debe contener al menos una letra mayúscula',
        newPasswordLowercase: 'La contraseña debe contener al menos una letra minúscula',
        newPasswordNumber: 'La contraseña debe contener al menos un número',
        newPasswordSpecial: 'La contraseña debe contener al menos un carácter especial',
        uppercase: 'Letras mayúsculas y minúsculas [A-Z]',
        lowercase: 'Letras minúsculas [a-z]',
        number: 'Números [0-9]',
        special: 'Caracteres especiales [!,@,#,$,%,^,&,* o *]',
        minLength: 'Mínimo 8 caracteres',
      },
    },
  },
  forms: {
    firmware: {
      title: 'Versión de Firmware',
      detailsFirmware: 'Detalles del Firmware: ',
      crcHexInfo: 'Valor de hex en decimal: ',
      fields: {
        crc: 'CRC (Hex o Decimal)',
        firmwareForSMC: 'Firmware para SMC',
        nameFirmware: 'Nombre de la versión:',
        manufacturer: 'Fabricante:',
      },
      validation: {
        crcRequired: 'CRC es obligatorio',
        crcPrefixError: 'Elimine el 0x o el espacio antes del número hexadecimal',
        crcInvalidError:
          'Valor inválido. Ingrese solo números decimales o hexadecimales (0-9, A-F)',
        crcImmutableInfo: 'El CRC no puede ser alterado después de la creación',
        nameFirmwareRequired: 'El nombre de la versión es obligatorio',
        manufacturerRequired: 'El fabricante es obligatorio',
      },
      actions: {
        registerFirmware: 'Registrar',
        editFirmware: 'Editar firmware',
        deleteFirmware: 'Eliminar firmware',
        deleteConfirmationTitle: 'Confirmar eliminación de firmware en masa',
        cancel: 'Cancelar',
      },
      placeholder: {
        crc: 'Ingrese el CRC',
        nameFirmware: 'Ingrese el nombre de la versión',
        selectManufacturer: 'Seleccione un fabricante',
        loadingManufacturers: 'Cargando fabricantes...',
      },
    },
    keys: {
      title: 'Registrar clave',
      titleEdit: 'Modificar Clave',
      fields: {
        serial: 'Serial',
        authenticationKey: 'Clave de Autenticación',
        encryptionKey: 'Clave de Cifrado',
        masterKey: 'Clave Maestra',
        lls2: 'LLS2',
      },
      validation: {
        fieldRequired: '¡Este campo es obligatorio!',
        serialImmutableInfo: 'El Serial no se puede cambiar después de la creación',
        keySize: 'Este campo debe contener 32 caracteres.',
        lls2Size: 'Este campo debe contener 16 (gateway) o 20 (medidor) caracteres.',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Registrar',
        update: 'Modificar',
        save: 'Guardar',
      },
    },
    tags: {
      title: 'Nueva Etiqueta',
      titleDetails: 'Detalles de la Etiqueta: ',
      fields: {
        name: 'Nombre',
        colors: 'Colores',
      },
      actions: {
        create: 'Crear etiqueta',
        update: 'Editar etiqueta',
        delete: 'Eliminar etiqueta',
        cancel: 'Cancelar',
        deleteConfirmationTitle: 'Confirmar eliminación de etiqueta en masa',
      },
      validation: {
        fieldRequired: '¡Este campo es obligatorio!',
      },
    },
    smcs: {
      title: 'Registrar nuevo SMC',
      titleEdit: 'Editar SMC',
      fields: {
        serial: 'Serial del SMC',
        description: 'Descripción',
        manufacturer: 'Fabricante',
        model: 'Modelo',
        latitude: 'Latitud',
        longitude: 'Longitud',
      },
      validation: {
        serialRequired: 'El serial es obligatorio',
        serialNoSpaces:
          'El serial del SMC no puede contener espacios al inicio, en el medio ni al final.',
        descriptionRequired: 'La descripción es obligatoria',
        manufacturerRequired: 'El fabricante es obligatorio',
        modelRequired: 'El modelo es obligatorio',
        warningDialogTittle:
          '¿Está seguro de que desea marcar las alarmas seleccionadas como leídas?',
        warningDialogMessage:
          'Al confirmar, se generará automáticamente un ticket con los datos del usuario responsable para fines de historial.',
        warningDialogTittleSingle: '¿Está seguro de que desea marcar esta alarma como leída?',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Crear SMC',
        update: 'Actualizar',
        confirm: 'Confirmar',
      },
      placeholders: {
        serial: 'Ingrese el serial del SMC',
        description: 'Ingrese la descripción del SMC',
        manufacturer: 'Ingrese el nombre del fabricante',
        model: 'Seleccione el modelo',
        latitude: 'Ingrese la latitud',
        longitude: 'Ingrese la longitud',
      },
    },
    clients: {
      title: 'Registrar nuevo cliente',
      titleEdit: 'Editar cliente',
      fields: {
        fullName: 'Nombre completo',
        location: 'Ubicación',
        weights: 'Pesos',
        prefixUf: 'Prefijo UF',
        selectAvailableMeters: 'Seleccionar Medidores Disponibles',
      },
      validation: {
        fullNameRequired: 'El nombre completo es obligatorio',
        locationRequired: 'La ubicación es obligatoria.',
        weightsInvalidFormat:
          'Ingrese pesos con un solo dígito por posición, separados por coma, espacio o punto y coma.',
        weightsInvalidLength: 'Cantidad de pesos no válida. Valores aceptados: 6, 7 o 10 dígitos.',
        prefixUfRequired: 'El Prefijo UF es obligatorio.',
        prefixUfInvalid: 'Ingrese un Prefijo UF válido.',
        meterSerialRequired: 'El serial del medidor es obligatorio',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Registrar',
        update: 'Actualizar',
      },
    },
    tariffs: {
      dateStart: 'Fecha de inicio',
      select: 'Seleccionar tipo de tarifa',
      dateActivation: 'Fecha de activación',
      send: 'Enviar',
    },
    models: {
      title: 'Registrar nuevo modelo',
      titleEdit: 'Editar modelo',
      fields: {
        name: 'Nombre',
        manufacturer: 'Fabricante',
        positionCount: 'Cantidad de posiciones',
      },
      validation: {
        nameRequired: 'El nombre es obligatorio',
        manufacturerRequired: 'El fabricante es obligatorio',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Registrar',
        update: 'Guardar',
      },
      placeholder: {
        name: 'Ingrese el nombre del modelo',
        selectManufacturer: 'Seleccione el fabricante',
        loadingManufacturers: 'Cargando fabricantes...',
        positionCount: 'Cantidad de posiciones',
      },
    },
  },
  tables: {
    noData: 'No hay datos encontrados',
    general: {
      search: 'Búsqueda rápida',
      status: 'Status',
      period: 'Período',
      dateRange: 'Intervalo de fechas',
      dateRangeError: 'Seleccione las fechas de inicio y fin.',
      quickOptions: 'Opciones rápidas',
      quickOptionsHint: 'seleccione un período sugerido',
      commands: 'Comandos',
      searchByEmail: 'Búsqueda por e-mail:',
      searchBySerial: 'Búsqueda por serial:',
      selectColumns: 'Seleccionar columnas:',
      commandsSelectionLimitSummary: 'Límite de selección',
      commandsSelectionLimitDetail: 'Puede seleccionar como máximo 5 comandos.',
      commandsSelectionRequiredSummary: 'Atención',
      commandsSelectionRequiredDetail: 'Seleccione al menos un comando.',
      selectStatus: 'Seleccionar estado:',
      searchByText: 'Busca por texto:',
      gatewayName: 'Nombre del Gateway:',
      commissioning: 'Comissionado:',
      typeSignalQuality: 'Tipo de señal:',
      gatewaySerial: 'Serial del Gateway:',
      type: 'Tipo:',
      details: 'Detalles',
      tags: 'Tags',
      selectTags: 'Seleccione las tags',
      selectOption: 'Seleccione una opción',
      all: 'Todos',
      error: 'Error',
      totalRecords: 'Total de registros: {totalRecords}',
      yes: 'Sí',
      no: 'No',
      placeholders: {
        searchByText: 'Realiza tu búsqueda aquí',
        gatewayName: 'Nombre del Gateway',
        gatewaySerial: 'Serial del Gateway',
        commissioning: 'Seleccionar comissionado',
        period: 'Seleccionar período',
        type: 'Seleccionar tipo',
        typeSignalQuality: 'Seleccionar tipo de señal',
        selectColumns: 'Seleccionar columnas',
      },
      tableChart: {
        showAll: 'Mostrar todo',
        showLess: 'Mostrar menos',
        displayedColumns: 'Columnas mostradas:',
        monoChartDisplayedColumns: 'Gráfico:',
      },
    },
    meterFileUpload: {
      massMemory: {
        dateTime: 'Fecha/Hora de lectura',
        totalEnergy_Wh: 'Totalizador general (Wh)',
        totalEnergyIncremental_Wh: 'Totalizador incremental (Wh)',
        q1ReactiveEnergy_VarH: 'Energía reactiva Q1 (VarH)',
        q4ReactiveEnergy_VarH: 'Energía reactiva Q4 (VarH)',
        group2VoltageVaH_V: 'Tensión Va (V)',
        group2VoltageVbH_V: 'Tensión Vb (V)',
        group2VoltageVcH_V: 'Tensión Vc (V)',
        group3CurrentIaH_A: 'Corriente Ia (A)',
        group3CurrentIbH_A: 'Corriente Ib (A)',
        group3CurrentIcH_A: 'Corriente Ic (A)',
        totalActiveEnergy_KWh: 'Energía activa total (kWh)',
        totalInductiveReactiveEnergy_KVarh: 'Energía reactiva inductiva total (kvarh)',
        totalCapacitiveReactiveEnergy_KVarh: 'Energía reactiva capacitiva total (kvarh)',
        totalReverseActiveEnergy_KWh: 'Energía activa inversa total (kWh)',
        reactiveEnergyImportQiiiRi_KVarH: 'Importación energía reactiva Q3 +Ri (kvarh)',
        reactiveEnergyImportQiiRc_KVarH: 'Importación energía reactiva Q2 +Rc (kvarh)',
        q1ReactiveEnergyIncremental_VarH: 'Energía reactiva Q1 incremental (kWh)',
        q4ReactiveEnergyIncremental_VarH: 'Energía reactiva Q4 incremental (kWh)',
        totalActiveEnergy_Wh: 'Energía activa directa (kWh)',
        totalDirectActiveEnergy_Wh: 'Energía activa directa total (kWh)',
        borderTotalizer_Wh: 'Totalizador punta (kWh)',
        reservedTotalizer_Wh: 'Totalizador fuera de punta (kWh)',
        offBorderTotalizer_Wh: 'Totalizador reservado (kWh)',
        totalIntermediary_Wh: 'Total intermediario (kWh)',
        generatedEnergyTotal_Wh: 'Energía generada - total (kWh)',
        totalReverseActiveEnergy_Wh: 'Energía activa inversa total (kWh)',
        totalDemand_W: 'Demanda activa total (W)',
        borderDemand_W: 'Demanda activa punta (W)',
        reservedDemand_W: 'Demanda activa fuera de punta (W)',
        totalApparentDemand_Va: 'Demanda aparente total (VA)',
        borderApparentDemand_Va: 'Demanda aparente punta (VA)',
        reservedApparentDemand_Va: 'Demanda aparente fuera de punta (VA)',
        totalDemandIncremental_W: 'Demanda activa total incremental (W)',
        borderDemandIncremental_W: 'Demanda activa punta incremental (W)',
        reservedDemandIncremental_W: 'Demanda activa fuera de punta incremental (W)',
        demandResetCount: 'Cantidad de reinicios de demanda',
        demandResetTime: 'Hora de reinicio de demanda',
        demandResetTimeMs: 'Hora de reinicio de demanda (ms)',
        demandCurrentTime: 'Hora actual de demanda',
        demandCurrentTimeMs: 'Hora actual de demanda (ms)',
        voltageA: 'Tensión A (V)',
        voltageB: 'Tensión B (V)',
        voltageC: 'Tensión C (V)',
        currentA: 'Corriente A (A)',
        currentB: 'Corriente B (A)',
        currentC: 'Corriente C (A)',
        maximumCurrentA_A: 'Corriente máxima A (A)',
        activePowerA: 'Potencia activa A (W)',
        activePowerB: 'Potencia activa B (W)',
        activePowerC: 'Potencia activa C (W)',
        lastAverageVoltageL1_V: 'Tensión media L1 (V)',
        lastAverageCurrentL1_A: 'Corriente media L1 (A)',
        lastAverageVoltageL2_V: 'Tensión media L2 (V)',
        lastAverageCurrentL2_A: 'Corriente media L2 (A)',
        lastAverageVoltageL3_V: 'Tensión media L3 (V)',
        lastAverageCurrentL3_A: 'Corriente media L3 (A)',
        totalPowerFactor_NoUnit: 'Factor de potencia total',
      },
      quality: {
        dateTimeInitial: 'Fecha/Hora Inicial',
        dateTimeFinal: 'Fecha/Hora Final',
        description: 'Descripción',
        drp: 'DRP (%)',
        drc: 'DRC (%)',
        dtt95: 'DTT95 (%)',
        fd95: 'FD95 (%)',
      },
      energy: {
        dateTime: 'Fecha/Hora',
        totalEnergy_Wh: 'Energía activa total (Wh)',
        borderTotalizer_Wh: 'Totalizador punta (Wh)',
        reservedTotalizer_Wh: 'Totalizador reservado (Wh)',
        offBorderTotalizer_Wh: 'Totalizador fuera de punta (Wh)',
        totalIntermediary_Wh: 'Totalizador intermediario (Wh)',
        generatedEnergyTotal_Wh: 'Energía generada total (Wh)',
        totalReverseActiveEnergy_Wh: 'Energía activa inversa total (kWh)',
        totalInductiveReactiveEnergy_VarH: 'Reactiva inductiva total (VarH)',
        totalCapacitiveReactiveEnergy_VarH: 'Reactiva capacitiva total (VarH)',
        consumedMaximunDemand_W: 'Demanda máxima consumida (W)',
        injectedMaximunDemand_W: 'Demanda máxima inyectada (W)',
        positiveReactiveEnergy_Wh: 'Energía reactiva positiva (kWh)',
        negativeReactiveEnergy_Wh: 'Energía reactiva negativa (kWh)',
        forderTotalizer_Wh: 'Energía activa directa T1 (kWh)',
        generatedOffBorderEnergyTotal_Wh: 'Energía activa generada fuera de punta (kWh)',
        generatedIntermediaryEnergyTotal_Wh: 'Energía activa generada intermediaria (kWh)',
        generatedBorderEnergyTotal_Wh: 'Energía activa generada punta (kWh)',
        generatedReservedEnergyTotal_Wh: 'Energía activa generada reservada (kWh)',
      },
      alarms: {
        dateEvent: 'Fecha evento',
        description: 'Descripción',
        serial: 'Serial',
        installation: 'Instalación',
        terminal: 'Terminal',
      },
    },
    meters: {
      title: 'Medidores',
      importMeters: 'Importar Medidores',
      editMeters: 'Editar Medidores',
      commissioning: 'Comissionamento',
      serial: 'Serial',
      installation: 'Instalación',
      modemSignalQuality: 'Señal',
      updatedAt: 'Actualizado en',
      readingsCount: 'Cantidad de Lecturas',
      totalOfSent: 'Total de Envios',
      successOfSent: 'Envios de éxito',
      accountantStatus: 'Situación',
      failOfSent: 'Envios de fallo',
      deviceEui: 'Device Eui',
      meterPhase: 'Fase',
      manufacturer: 'Fabricante',
      position: 'Posición',
      commands: 'Comandos',
      tags: 'Etiquetas',
      firmware: 'Firmware',
      phase: 'Fase',
      communication: 'Comunicación',
      status: 'Estado',
    },
    smcs: {
      title: 'Smcs',
      serial: 'Serial',
      qtyMeters: 'Cantidad',
      firmware: 'Firmware',
      comissioned: 'Comisionado',
      doorStatus: 'Puerta',
      online: 'Estado de comunicación',
      smcModel: 'Marca',
      signalQuality: 'Señal',
      updatedAt: 'Última Actualización',
    },
    alarms: {
      title: 'Alarmas',
      serial: 'Serial',
      description: 'Descripción',
      dateTime: 'Fecha y Hora',
      alarmType: 'Tipo de Alarma',
      selectAlarmType: 'Seleccionar tipo de alarma',
      terminal: 'Terminal',
      updatedAt: 'Última actualización',
      isCritical: 'Alarma Crítica',
      errors: {
        error: 'Error',
        incompleteMeterData: 'Datos del medidor incompletos para exportación',
      },
    },
    smcAlarms: {
      title: 'Alarmes del SMC',
      readDateTime: 'Fecha y Hora de lectura',
      description: 'Descripción',
      updatedAt: 'Última actualización',
    },
    meterAlarms: {
      title: 'Alarmes de los Medidores',
      readDateTime: 'Fecha y Hora de lectura',
      description: 'Descripción',
      updatedAt: 'Última actualización',
      serial: 'Serial',
      terminal: 'Terminal',
    },
    alarmTypesMeter: {
      title: 'Tabla de Eventos SMI/Medidores del SMC',
      description: 'Descripción',
      count: 'Cantidad',
      wasRead: 'Lectura',
      read: 'Leído',
      unread: 'No Leído',
      errorSearch: 'Error al buscar tipos de alarmas',
    },
    alarmTypesSmc: {
      title: 'Tabla de Eventos del SMC',
      description: 'Descripción',
      count: 'Cantidad',
      wasRead: 'Lectura',
      read: 'Leído',
      unread: 'No Leído',
      errorSearch: 'Error al buscar tipos de alarmas',
    },
    tickets: {
      title: 'Tickets',
      serial: 'Serial',
      commandType: 'Comando',
      ticketStatus: 'Estado del Ticket',
      selectTicketStatus: 'Seleccione el estado del ticket',
      statusCommand: 'Estado del Comando',
      lastUpdate: 'Última actualización',
      initialDate: 'Inicio',
      updatedAt: 'Actualizado en',
      serialMeter: 'Serial del Medidor',
      user: 'Usuario responsable',
      scheduledTickets: 'Tickets Agendados',
      scheduledDate: 'Fecha Programada',
      company: 'Empresa',
      deadline: 'Deadline',
      startDate: 'Inicio de la Ejecución',
      trackingCode: 'Código',
      serviceType: 'Tipo de Servicio',
      status: 'Status del SAP',
      commandTicket: {
        commandId: 'ID del Comando',
        commandType: 'Tipo de Comando',
        initialDate: 'Inicio',
        finishDate: 'Fin',
        attempt: 'Número de intentos',
        messageSent: 'Mensaje enviado',
        messageReceived: 'Mensaje recibido',
        messageError: 'Mensaje de error',
        messageSuccess: 'Mensaje de éxito',
        noResponse: 'Sin respuesta',
        totalData: 'Total de Datos',
        saved: 'Guardados',
        failedProcesses: 'Procesos con fallas',
        answerColumns: {
          answer: 'Respuesta',
          lineNumber: 'Línea',
          operation: 'Operación',
          success: 'Éxito',
          message: 'Mensaje',
          processedAt: 'Procesado en',
          position: 'Posición',
          totalEnergy: 'Energía total',
          relayStatus: 'Estado del relé',
          accountantStatus: 'Estado del relé',
          serial: 'Serial',
          datetime: 'Fecha/Hora',
          group2VoltageVaH_V: 'Tensión VaH(V)',
          group3CurrentIaH_A: 'Corriente IaH(A)',
          group2VoltageVbH_V: 'Tensión VbH(V)',
          group3CurrentIbH_A: 'Corriente IbH(A)',
          group2VoltageVcH_V: 'Tensión VcH(V)',
          group3CurrentIcH_A: 'Corriente IcH(A)',
          group4AngleUiA_deg: 'Ángulo UiA(º)',
          group4AngleUiB_deg: 'Ángulo UiB(º)',
          group4AngleUiC_deg: 'Ángulo UiC(º)',
          index: 'Índice',
          specialDayDate: 'Fecha especial',
          dayOfWeek: 'Día de la semana',
          dayId: 'ID del día',
          meterId: 'ID del medidor',
          type: 'Tipo',
          name: 'Nombre',
          description: 'Descripción',
          time: 'Hora',
          tariffType: 'Tipo de tarifa',
          dailyTariffs: 'Tarifas diarias',
          hourlyTariffs: 'Tarifas horarias',
          drmcDailyTariffs: 'Tarifas diarias DMCR',
          drmcHourlyTariff: 'Tarifas horarias DMCR',
          dmcrType: 'Tipo DMCR',
          hourlyDMCRs: 'DMCRs horarios',
          meterProfileId: 'ID del perfil del medidor',
          meterDMCRProfileId: 'ID del perfil DMCR del medidor',
          startDate: 'Fecha de inicio',
          endDate: 'Fecha de fin',
          deviation: 'Desviación',
          isEnable: 'Activo',
          enabled: 'Activo',
          saturdayInductive: 'Sábado inductivo',
          saturdayCapacitive: 'Sábado capacitivo',
          sundayInductive: 'Domingo inductivo',
          sundayCapacitive: 'Domingo capacitivo',
          workdayInductive: 'Día hábil inductivo',
          workdayCapacitive: 'Día hábil capacitivo',
          holidayInductive: 'Feriado inductivo',
          holidayCapacitive: 'Feriado capacitivo',
          timeToActivate: 'Tiempo de activación',
          daylightEndDatetime: 'Fecha/Hora de fin del horario de verano',
          daylightBeginDatetime: 'Fecha/Hora de inicio del horario de verano',
        },
      },
    },
    frozenData: {
      title: 'Totalizadores de Energía',
    },
    massMemory: {
      title: 'Memoria de Masa',
    },
    tableFiscalFasional: {
      title: 'Página Fiscal',
    },
    billing: {
      title: 'Histórico de Facturación',
      billing: 'Facturación',
      stageCode: 'Etapa',
      stageDay: 'Dia',
      dateSent: 'Enviado el',
      status: 'Estado',
      type: 'Tipo',
      typeCode: 'Tipo de código',
      readingDate: 'Fecha de lectura',
      readingValue: 'Valor de lectura',
    },
    eventLogs: {
      title: 'Registros de Eventos',
      dateTime: 'Fecha y Hora',
      message: 'Mensaje',
      logLevel: 'Nivel de Log',
      logs: {
        critical: 'Crítico',
        debug: 'Debug',
        error: 'Error',
        trace: 'Detallada ( Apenas Degub )',
        warning: 'Aviso',
        none: 'Sin mensaje',
        information: 'Información',
      },
      errors: {
        getEventLogs: 'Error al obtener los logs de eventos',
        serialRequired: 'El serial es requerido',
      },
    },
    alarmVoltage: {
      titleShortDuration: 'Alarmas de Interrupción de corta duración',
      titleLongDuration: 'Alarmas de de Interrupción larga duración',
      calculateInterruptionIndicators: 'Calcular Indicadores de Interrupción',
      referenceMonth: 'Mes de referencia',
      calculate: 'Calcular',
      fic: 'FIC',
      dic: 'DIC',
      hours: 'Horas',
      hundredthHour: 'Centésimos de horas',
      minutes: 'Minutos',
      ficTooltip: 'Frecuencia de Interrupción Individual por Unidad de Consumo o Punto de Conexión',
      dicTooltip:
        'Duración de Interrupción Individual por Unidad de Consumo o Punto de Conexión expresada en Horas',
      dicHundredthHourTooltip:
        'Duración de Interrupción Individual por Unidad de Consumo o Punto de Conexión expresada en Centésimos de Horas',
      dateTime: 'Fecha de Lectura',
      voltageOut: 'Voltaje',
      createdAt: 'Creado en',
      dateTimeStart: 'Fecha y Hora de Inicio',
      dateTimeEnd: 'Fecha y Hora de Fin',
      timeVariation: 'Variación de Tiempo',
    },
    alarmsMeters: {
      title: 'Alarmes de los Medidores',
    },
    qeeIndicators: {
      title: 'Parámetros de Calidad',
      monthlyAverage: 'Media Mensual',
      recoverQualityParams: 'Recuperar parámetros de calidad',
      calculateMonthlyAverage: 'Calcular media mensual',
      dateAndTimeInitial: 'Fecha y Hora inicial',
      dateAndTimeFinal: 'Fecha y Hora final',
      referenceMonth: 'Mes de Referencia',
      meterStatus: 'Estado del Medidor',
      onlineStatus: 'Estado Online',
      description: 'Descripción',
      commissioned: 'Comissionado',
      dateTime: 'Fecha y hora',
      drp: 'DRP',
      drc: 'DRC',
      dic: 'DIC',
      fic: 'FIC',
      dmic: 'DMIC',
      dmicOccurrenceTime: 'Hora de Ocurrencia DMIC',
      noInformation: 'Sin información',
      dialog: {
        referenceMonth: 'Mes de Referencia',
        quantityOfSamples: 'Cantidad de muestras deseadas',
        initialDate: 'Fecha Inicial del Conjunto',
        endDate: 'Fecha Final del Conjunto',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        drcPhaseA: 'DRC Fase A',
        drpPhaseA: 'DRP Fase A',
        drcPhaseB: 'DRC Fase B',
        drpPhaseB: 'DRP Fase B',
        drcPhaseC: 'DRC Fase C',
        drpPhaseC: 'DRP Fase C',
        calculate: 'Calcular',
        cancel: 'Cancelar',
        request: 'Solicitar',
        requestSentTitle: 'Solicitud Enviada',
        requestSentSuccess: 'Media mensual solicitada con éxito',
        requestSentError: 'No fue posible solicitar la Media Mensual',
        relayOff: 'Relé apagado',
        relayOffDescription: 'No fue posible solicitar la media mensual para este medidor',
        noQualityParametersFound: 'No se encontró ningún parámetro de calidad para el medidor',
      },
      placeholders: {
        referenceMonth: 'Seleccione el mes de referencia',
      },
      errors: {
        incompleteMeterData: 'Datos del medidor incompletos para exportación',
      },
    },
    instantMeasure: {
      title: 'Mediciones Instantáneas',
      requestMeasure: 'Solicitar lecturas',
      readingTime: 'Hora de lectura',
      voltageVa: 'Tensión Va (V)',
      voltageVb: 'Tensión Vb (V)',
      voltageVc: 'Tensión Vc (V)',
      currentIa: 'Corriente Ia (A)',
      currentIb: 'Corriente Ib (A)',
      currentIc: 'Corriente Ic (A)',
      angleUiA: 'Ángulo Ui A (º)',
      angleUiB: 'Ángulo Ui B (º)',
      angleUiC: 'Ángulo Ui C (º)',
    },
    firmware: {
      lastUpdate: 'Última actualización',
      crc: 'CRC',
      name: 'Nombre',
      manufacturer: 'Fabricante',
    },
    keys: {
      lastUpdate: 'Última actualización',
      serial: 'Serial',
      authenticationKey: 'Clave de Autenticación',
      encryptionKey: 'Clave de Cifrado',
      masterKey: 'Clave Maestra',
      lls2: 'LLS2',
    },
    tags: {
      lastUpdate: 'Última Actualización',
      tagId: 'ID de la Etiqueta',
      name: 'Nombre',
      colorCode: 'Color (Código Hexadecimal)',
      colors: 'Colores',
    },
    models: {
      name: 'Nombre',
      manufacturer: 'Fabricante',
      positionCount: 'Cant. de posiciones',
    },
    clients: {
      title: 'Clientes',
      newClient: 'Nuevo Cliente',
      deleteClients: 'Eliminar Clientes',
      name: 'Nombre',
      location: 'Ubicación',
      statusActive: 'Activo',
      quantityMeterSerials: 'Cantidad de Medidores',
      updatedAt: 'Última actualización',
      weights: 'Pesos',
      prefixUf: 'Prefijo UF',
    },
    process: {
      title: 'Procesos',
      processId: 'ID del Proceso',
      processType: 'Tipo de Proceso',
      user: 'Usuario',
    },
    balanceDevices: {
      title: 'Balance de los Dispositivos',
      trafo: 'Trafo',
      device: 'Dispositivo',
      initialDate: 'Fecha Energía Consumida Inicial',
      initialReading: 'Lectura Inicial Energía Consumida (kWh)',
      finalDate: 'Fecha Energía Consumida Final',
      finalReading: 'Lectura Final Energía Consumida (kWh)',
      consumption: 'Consumo (kWh)',
      energyInjectedConsumers: 'Energía Inyectada (kWh)',
      energyReverseTransformer: 'Energía Reversa (kWh)',
    },
    balanceTransformers: {
      title: 'Balance de los Transformadores',
      date: 'Fecha',
      nameTrafo: 'Nombre del Trafo',
      trafoMeter: 'Medidor del Trafo',
      energyRequired: 'Energía Requerida (kWh)',
      energyConsumed: 'Energía Consumida (kWh)',
      loss: 'Pérdida (kWh)',
      streetLighting: 'Energía IP (kWh)',
      lossPercentage: 'Pérdida %',
    },
    balanceAreasRegions: {
      title: 'Balance de las Áreas',
      data: 'Fecha',
      nameArea: 'Nombre del Área',
      energyRequired: 'Energía Requerida (kWh)',
      energyConsumed: 'Energía Consumida (kWh)',
      loss: 'Pérdida (kWh)',
      streetLighting: 'Energía pública (kWh)',
      lossPercentage: 'Pérdida %',
    },
    transformers: {
      title: 'Transformadores',
      newTransformer: 'Nuevo Transformador',
      deleteTransformers: 'Exclusión de Transformadores',
      name: 'Nombre',
      description: 'Descripción',
      publicLighting: 'Iluminación Pública Mensual (kWh)',
      trafoMeter: 'Medidor Trafo',
      connected: 'Conectados',
      latLong: 'Lat/Long',
      updatedAt: 'Última actualización',
      errorSearch: 'Error al buscar Transformadores',
      noTransformerSelected: 'Ningún transformador seleccionado',
    },
    scheduledCommands: {
      group: 'Grupo',
      command: 'Comando',
      executionTime: 'Tiempo de Ejecución',
      status: 'Estado',
      nextExecution: 'Próxima Ejecución',
      active: 'Activo',
      paused: 'Pausado',
      pausedScheduling: 'Programación Pausada',
      scheduling: 'programación',
      errorSearch: 'Error al buscar programaciones',
      noScheduleSelected: 'Ninguna programación seleccionada',
      noSchedule: 'Ninguna programación registrada',
      deleteSchedule: 'Eliminación de Programación',
      newRoutine: 'Programar Comando',
    },
    lowEffectiveness: {
      title: 'Ubicaciones con Baja Efectividad',
      locationCode: 'Código de Ubicación',
      regionCode: 'Código de Región',
      totalMeters: 'Total de Medidores',
      lowEffectivenessMeters: 'Medidores con Baja Efectividad',
      lowEffectivenessPercent: 'Porcentaje de Baja Efectividad',
      effectivenessPercent: 'Porcentaje de Efectividad',
      errorSearch: 'Error al buscar ubicaciones con baja efectividad',
    },
    unavailabilityPeak: {
      title: 'Pico de Indisponibilidad',
      meter: 'Medidor',
      consumerUnit: 'Unidad Consumidora',
      locationCode: 'Código de Ubicación',
      regionCode: 'Código de Región',
      manufacturer: 'Fabricante',
      unavailableDays: 'Días Indisponibles',
      totalDays: 'Total de Días',
      unavailabilityPercent: 'Porcentaje de Indisponibilidad',
      availabilityPercent: 'Porcentaje de Disponibilidad',
      errorSearch: 'Error al buscar picos de indisponibilidad',
    },
    areas: {
      title: 'Áreas',
      newArea: 'Nova Área',
      name: 'Nombre',
      description: 'Descripción',
      transformersCount: 'Cantidad de Transformadores',
      updatedAt: 'Última actualización',
      deleteAreas: 'Exclusión de Áreas',
      errors: {
        title: 'Error',
        loadAreaInfo: 'Error al buscar información de la área',
        noAreaSelected: 'Ninguna área seleccionada',
      },
      areasTransformers: {
        title: 'Transformadores de la Área',
        manageTransformers: 'Gestionar transformadores',
        name: 'Nombre',
        serialMeter: 'Serial del Medidor',
        metersCount: 'Cantidad de Medidores',
        publicLighting: 'Iluminación Pública',
        coordinates: 'Coordenadas',
        updatedAt: 'Última actualización',
      },
    },
    regions: {
      title: 'Regiones',
      newRegion: 'Nueva Región',
      deleteRegions: 'Exclusión de Regiones',
      name: 'Nombre',
      description: 'Descripción',
      areasCount: 'Cantidad de Áreas',
      updatedAt: 'Última actualización',
      errors: {
        title: 'Error',
        loadRegions: 'Error al buscar regiones',
        noRegionSelected: 'Ninguna región seleccionada',
      },
    },
    regionsAreas: {
      title: 'Áreas de la Región',
      manageAreas: 'Gestionar áreas',
      name: 'Nombre',
      description: 'Descripción',
      transformersCount: 'Cantidad de Transformadores',
      updatedAt: 'Última actualización',
    },
    transformerMeters: {
      title: 'Medidores del Transformador',
      importMeters: 'Importar medidores por archivo',
      removeMeters: 'Remover medidores por archivo',
      manageMeters: 'Gestionar medidores',
      importNameModal: 'modelo-medidores-por-transformador-registro',
      removeNameModal: 'modelo-medidores-por-transformador-remocao',
      meter: 'medidor(es)',
      success: {
        registerMeters: 'Medidores registrados con éxito',
        removeMeters: 'Medidores removidos con éxito',
      },
      errors: {
        registerMeters: 'Error al registrar medidores',
        removeMeters: 'Error al remover medidores',
        metersNotRegistered: 'medidor(es) no pudieron ser registrados',
        unknownReason: 'Motivo desconocido',
      },
      warnings: {
        partialSuccess: 'Registro parcial de medidores',
        metersNotUpdated: 'medidor(es) no fueron actualizados',
      },
    },
  },
  echarts: {
    noteType: {
      title: 'Tipo de Servicio',
      services: 'Servicios',
      regions: 'Regiones',
      manufactures: 'Fabricantes',
    },
    sapStatus: {
      title: 'Estado SAP',
      services: 'Servicios',
      regions: 'Regiones',
      manufactures: 'Fabricantes',
    },
    requestStatus: {
      title: 'Estado Comando',
      status: 'Estado',
      services: 'Servicios',
      regions: 'Regiones',
      manufactures: 'Fabricantes',
    },
    table: {
      createdAt: 'Creado el',
      updatedAt: 'Actualizado el',
      startDate: 'Inicio de la Ejecución',
      actionType: 'Tipo de acción',
      status: 'Estado',
      company: 'Región',
      meterSerial: 'Serial',
      trackingCode: 'Seguimiento',
    },
    effectiveness: {
      title: 'Efectividad y Disponibilidad',
      manufacturers: 'Fabricantes',
      networkTech: 'Tecnología de Red',
      cityOrState: 'Ciudad / Estado',
      cityOrStatePlaceholder: 'Ingrese el nombre de la ciudad/estado',
      meterRegion: {
        serial: 'Serial',
        regionCode: 'Código de Región',
        districtCode: 'Código de Distrito',
        sectionCode: 'Código de Sección',
        locationTypeCode: 'Código de Tipo de Ubicación',
        locationCode: 'Código de Ubicación',
        fullAddress: 'Dirección Completa',
        city: 'Ciudad',
        feeder: 'Alimentador',
        districtName: 'Nombre del Distrito',
        neighborhood: 'Barrio',
        regional: 'Regional',
        sectional: 'Seccional',
      },
    },
    process: {
      title: 'Estado',
      success: 'Éxito',
      failed: 'Fallido',
      waiting: 'Esperando',
      executing: 'Ejecutando',
      scheduled: 'Programado',
    },
    status: {
      title: 'Status',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      statusAbsent: 'Ausente',
    },
    commission: {
      title: 'Comissionamento',
      commissionOn: 'Comisionado',
      commissionOff: 'No Comissionado',
      commissionOns: 'Comissionados',
      commissionOffs: 'No Comissionados',
    },
    situation: {
      title: 'Situación',
      disabled: 'Desconectado',
      activated: 'Conectado',
      noRelay: 'Sin Relé',
      noInformation: 'Sin Información',
      titleNoMeters: 'Tabla de Situación - Medidores',
    },
    billing: {
      title: 'Información sobre la facturación',
      status: 'Estado',
      success: 'Éxito',
      noReadings: 'Sin lecturas',
      noReadingsDescription: 'No se encontraron lecturas disponibles para la facturación.',
      withReadings: 'Con lecturas',
      withReadingsDescription:
        'Había lecturas, pero ocurrió un error al enviarlas al sistema comercial.',
      withoutStage: 'Sin etapa',
      withoutStageDescription: 'Aún no hay etapa de facturación asignada a este medidor.',
      scheduled: 'Agendado',
      scheduledDescription:
        'Facturación programada para una fecha futura dentro del período definido.',
      notStarted: 'Facturación no iniciada',
      notStartedDescription: 'La fecha de facturación ya pasó y el proceso no se ejecutó.',
      successDescription: 'Facturación realizada con éxito, sin ocurrencias de errores.',
    },
    signalQuality: {
      signal: 'Señal',
      title: 'Calidad de la señal',
      period: 'Período',
      dateRange: 'Intervalo de fechas',
      fiveBars: '5 Barras',
      fourBars: '4 Barras',
      threeBars: '3 Barras',
      twoBars: '2 Barras',
      oneBar: '1 Barra',
      unregistered: 'Sin registro',
      metersWith: 'Medidores con',
    },
    commandsSent: {
      title: 'Comandos Enviados',
    },
    statusCommand: {
      title: 'Todos los Comandos',
    },
    alarmStatisticMeter: {
      title: 'Eventos SMI/Medidores del SMC',
      read: 'Leídos',
      unread: 'No leídos',
    },
    alarmStatisticSmc: {
      title: 'Eventos SMC',
      read: 'Leídos',
      unread: 'No leídos',
    },
    fiscalPage: {
      title: 'Página Fiscal',
      noData: 'No hay datos disponibles',
      noDataOnInterval: 'No hay datos para el intervalo seleccionado',
      noDataChart: 'Sin datos',
      requestFiscalPage: 'Solicitar Página Fiscal',
      value: 'Valor',
      phaseA: 'Fase A',
      phaseB: 'Fase B',
      phaseC: 'Fase C',
      packageDate: 'Fecha del paquete',
      frequency: 'Frecuencia (Hz)',
      voltage: 'Tensión (V)',
      angleVI: 'Angulo VI (°)',
      angleVoltage: 'Angulo Tensión (°)',
      anglePhase: 'Angulo Fase (AB/BC/CA °)',
      current: 'Corriente',
      currentAngle: 'Angulo Corrente (°)',
      activePower: 'Potencia Activa (W)',
      reactivePower: 'Potencia Reactiva (VAR)',
      powerFactor: 'Factor de Potencia',
      legend: {
        angVoltageA: 'Angulo Tensión A',
        angVoltageB: 'Angulo Tensión B',
        angVoltageC: 'Angulo Tensión C',
        angVIA: 'Angulo VI A',
        angVIB: 'Angulo VI B',
        angVIC: 'Angulo VI C',
        angPhaseAB: 'Angulo Fase AB',
        angPhaseBC: 'Angulo Fase BC',
        angPhaseCA: 'Angulo Fase CA',
        angPhaseAC: 'Angulo Fase AC',
        currentAngleA: 'Angulo Corrente A',
        currentAngleB: 'Angulo Corrente B',
        currentAngleC: 'Angulo Corrente C',
      },
    },
  },
  notifications: {
    effectiveness: {
      success: {
        updateConfig: '¡Configuración de efectividad actualizada con éxito!',
      },
      error: {
        updateConfig: 'Error al actualizar la configuración de efectividad.',
        getConfig: 'Error al buscar la configuración de efectividad.',
      },
    },
    averageVariation: {
      success: {
        updateConfig: '¡Configuración actualizada con éxito!',
      },
      error: {
        updateConfig: 'Error al actualizar la configuración.',
        getConfig: 'Error al buscar la configuración.',
      },
    },
    tickets: {
      success: {
        getTickets: 'Tickets buscados con éxito',
      },
      error: {
        getTickets: 'Error al buscar Tickets',
      },
    },
    fiscalPage: {
      success: {
        getFiscalPage: 'Página fiscal recuperada con éxito',
      },
      error: {
        getFiscalPage: 'Error al recuperar página fiscal',
      },
    },
    recoverEnergy: {
      success: {
        recoverEnergy: 'Totalizadores de energia recuperados con éxito',
      },
      error: {
        recoverEnergy: 'Error al recuperar totalizadores de energia',
      },
    },
  },
  dialogs: {
    deleteMass: {
      title: 'Confirmar eliminación en masa',
      message: '¿Está seguro de que desea eliminar los elementos seleccionados?',
      confirmButton: 'Sí, eliminar',
      cancelButton: 'Cancelar',
    },
    recoverByRangeDate: {
      title: 'Enviar comando',
      description: 'Seleccione el intervalo de fechas',
      placeholder: 'Intervalo de fechas',
      confirmButton: 'Requisitar',
      cancelButton: 'Cancelar',
    },
    importModal: {
      downloadModel: 'Descargar Modelo',
      chooseFile: 'Elegir Archivo',
      fileNotSelected: 'Archivo no seleccionado',
      validateFile: 'Validar Archivo',
      importItems: 'Importar Elementos',
      viewValidatedItems: 'Ver Elementos Validados',
      viewIgnoredItems: 'Ver Elementos Ignorados',
      serialWhitespaceError:
        'El serial no puede contener espacios al inicio, en el medio ni al final. Filas inválidas: {rows}.',
    },
    dialogTransformer: {},
    dialogArea: {
      titleNewArea: 'Nueva Área',
      titleEditArea: 'Editar Área',
      name: 'Nombre',
      fieldRequired: 'Este campo es obligatorio!',
      description: 'Descripción',
      delete: 'Eliminar',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Registrar',
      success: {
        title: 'Éxito',
        createArea: 'Área creada con éxito!',
        updateArea: 'Área actualizada con éxito!',
      },
      error: {
        title: 'Error',
        createArea: 'Error al crear área',
        updateArea: 'Error al actualizar área',
      },
    },
    dialogRegion: {
      editRegion: 'Editar región',
      createRegion: 'Crear región',
      title: 'Gestionar transformadores de la región',
      name: 'Nombre',
      fieldRequired: 'Este campo es obligatorio!',
      description: 'Descripción',
      deleteRegion: 'Eliminar',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Registrar',
      success: {
        title: 'Éxito',
        createRegion: 'Región creada con éxito!',
        updateRegion: 'Región actualizada con éxito!',
      },
      error: {
        title: 'Erro',
        createRegion: 'Error al crear región',
        updateRegion: 'Error al actualizar región',
      },
    },
    dialogNewEditAreasInRegion: {
      title: 'Gestionar áreas de la región',
      areasInRegion: 'Áreas en la Región',
      total: 'Total',
      availableAreas: 'Áreas Disponibles',
      available: 'Disponibles',
      selected: 'Seleccionadas',
      removeAreas: 'Remover Áreas',
      addAreas: 'Agregar Áreas',
      exit: 'Salir',
      name: 'Nombre',
      description: 'Descripción',
      transformersCount: 'Transformadores',
      updatedAt: 'Última actualización',
      success: {
        title: 'Éxito',
        addAreas: 'Áreas agregadas con éxito!',
        removeAreas: 'Áreas eliminadas con éxito!',
      },
      errors: {
        title: 'Erro',
        loadAvailableAreas: 'Error al cargar áreas disponibles',
        addAreas: 'Error al agregar áreas a la región',
        removeAreas: 'Error al remover áreas de la región',
      },
    },
    dialogNewEditTransformersInArea: {
      title: 'Gestionar transformadores de la área',
      transformersInArea: 'Transformadores en la Área',
      total: 'Total',
      availableTransformers: 'Transformadores Disponibles',
      available: 'Disponibles',
      selected: 'Seleccionados',
      removeTransformers: 'Remover Transformadores',
      addTransformers: 'Agregar Transformadores',
      exit: 'Salir',
      name: 'Nombre',
      serialMeter: 'Serial del Medidor',
      meters: 'Medidores',
      updatedAt: 'Última actualización',
      success: {
        title: 'Éxito',
        addTransformers: 'Transformadores agregados con éxito!',
        removeTransformers: 'Transformadores removidos con éxito!',
      },
      errors: {
        title: 'Erro',
        loadAvailableTransformers: 'Error al cargar transformadores disponibles',
        addTransformers: 'Error al agregar transformadores a la área',
        removeTransformers: 'Error al remover transformadores de la área',
      },
    },
    dialogNewEditMetersInTransformer: {
      title: 'Gestionar medidores del transformador',
      registeredMeters: 'Medidores Registrados',
      availableMeters: 'Medidores Disponibles',
      total: 'Total',
      available: 'Disponibles',
      selected: 'Seleccionados',
      removeMeters: 'Remover Medidores',
      registerMeters: 'Registrar Medidores',
      exit: 'Salir',
      serialMeter: 'Serial del Medidor',
      manufacturer: 'Fabricante',
      phase: 'Fase',
      signalQuality: 'Calidad de la señal',
      success: {
        title: 'Éxito',
        registerMeters: 'Medidores registrados con éxito',
        removeMeters: 'Medidores removidos con éxito',
      },
      errors: {
        title: 'Erro',
        registerMeters: 'Error al registrar medidores',
        removeMeters: 'Error al remover medidores',
      },
    },
    dialogNewEditTransformer: {
      editTransformer: 'Editar Transformador',
      registerTransformer: 'Registrar Transformador',
      requiredField: 'Este campo es obligatorio!',
      requiredFields: 'Rellene todos los campos obligatorios',
      name: 'Nombre',
      publicLighting: 'Iluminación Pública Mensual (kWh)',
      latitude: 'Latitude',
      longitude: 'Longitude',
      readingMeter: 'Medidor de Leitura',
      searchPlaceholder: 'Buscar por nombre, fabricante o serial',
      description: 'Descripción',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Registrar',
      success: {
        title: 'Éxito',
        createTransformer: 'Transformador creado con éxito!',
        updateTransformer: 'Transformador actualizado con éxito!',
      },
      errors: {
        title: 'Erro',
        createTransformer: 'Error al crear transformador',
        updateTransformer: 'Error al actualizar transformador',
      },
    },
    dialogCancelTicket: {
      title: 'Cancelar ejecución del ticket',
      message: '¿Desea cancelar la ejecución de este ticket?',
      ticketLabel: 'Ticket',
      commandLabel: 'Comando',
      close: 'Cerrar',
      cancelTicket: 'Cancelar Ticket',
      success: {
        title: 'Éxito',
        message: '¡Cancelación ejecutada con éxito!',
      },
      error: {
        title: 'Error',
        message: 'Error al cancelar ticket',
      },
    },
  },
  general: {
    cancel: 'Cancelar',
    save: 'Guardar',
    meter: 'Medidor',
    meters: 'Medidores',
    serial: 'Serial',
    attention: 'Atención',
    noInformation: 'Sin Información',
    notAvailable: 'No disponible',
    noDataFound: 'Ningún dato encontrado',
    itemsFound: 'elementos encontrados',
    actionsFile: 'Acciones desde archivo',
    consumerUnit: 'Unidad Consumidora',
    yes: 'Si',
    no: 'No',
    exit: 'Salir',
    success: 'Éxito',
    error: 'Error',
    maximizeMap: 'Maximizar Mapa',
    minimizeMap: 'Minimizar Mapa',
    validation: {
      requiredFields: 'Verifique los campos obligatorios antes de continuar.',
      meterSerialRequired: 'El serial del medidor es obligatorio.',
      manufacturerRequired: 'El fabricante es obligatorio.',
      phaseRequired: 'La fase es obligatoria.',
      meterModelRequired: 'El modelo es obligatorio.',
      meterTypeRequired: 'El tipo de medidor es obligatorio.',
      rateTypeRequired: 'El tipo de tarifa es obligatorio.',
      installationRequired: 'El código de instalación es obligatorio.',
      connectionPhaseRequired: 'La fase de conexión es obligatoria.',
      serialCannotContainSpaces:
        'El serial no puede contener espacios al inicio, en el medio ni al final.',
      meterSerialCannotContainSpaces:
        'El serial del medidor no puede contener espacios al inicio, en el medio ni al final.',
      smcSerialCannotContainSpaces:
        'El serial del SMC no puede contener espacios al inicio, en el medio ni al final.',
      meterRegistersRequired: 'Los registradores son obligatorios.',
    },
    comissionedType: {
      all: 'Todos',
      comissioned: 'Comissionado',
      notComissioned: 'No Comissionado',
      notRegistered: 'No Registrado',
    },
    meterTypes: {
      all: 'Todos',
      nepen: 'Integración MDX',
      integration: 'Integración',
      integrationDcu: 'Integración Wasion DCU',
    },
    meterActivated: {
      activated: 'Conectado',
      notActivated: 'Desconectado',
      deactivateConfirmation: '¿Desea desconectar este relé?',
      activateConfirmation: '¿Desea conectar este relé?',
      deactivateMessage: 'Comando de Desconexión de Relé Enviado',
      activateMessage: 'Comando de Conexión de Relé Enviado',
    },
    doorStatus: {
      authorized: 'Autorizado',
      unauthorized: 'Desautorizado',
    },
    communicationStatus: {
      online: 'Online',
      waiting: 'Esperando',
      offline: 'Offline',
      pending: 'Pendiente',
    },
    signalQuality: {
      neverSeen: 'Nunca Visto',
      veryWeak: 'Muy Fraco (1 Barra)',
      weak: 'Fraco (2 Barras)',
      reasonable: 'Razonable (3 Barras)',
      strong: 'Fuerte (4 Barras)',
      excellent: 'Excelente (5 Barras)',
    },
    signalQualityBars: {
      fiveBars: '5 Barras',
      fourBars: '4 Barras',
      threeBars: '3 Barras',
      twoBars: '2 Barras',
      oneBar: '1 Barra',
    },
    signalQualityLabel: {
      neverSeen: 'Nunca Visto',
      veryWeak: 'Muy Fraco',
      weak: 'Fraco',
      reasonable: 'Razonable',
      strong: 'Fuerte',
      excellent: 'Excelente',
    },
    datePickerExecutionFilter: 'Filtro por fecha de inicio de ejecución',
  },
  manufacturerFilter: {
    label: 'Fabricantes',
    placeholder: 'Todos los fabricantes',
    loading: 'Cargando fabricantes...',
  },
  parametrization: {
    parametrization: 'Parametrización',
    manageParams: 'Gestionar Parámetros',
    searchBySerial: 'Buscar por Serial',
    unity: 'Unidad de Consumo',
    manufacturer: 'Fabricante',
    actions: 'Acciones',
    commands: {
      timeParams: 'Parámetros Relacionados con el Tiempo',
      createDataTemplate: 'Crear Plantilla de Fecha',
      requestHolidays: 'Solicitar Feriados',
      createHolidayTemplate: 'Crear Plantilla de Feriado',
      deleteHolidayTemplate: 'Eliminar Plantilla de Feriado',
      activateProfileActivityCalendar: 'Definir Estado del Perfil',
      addActivateTime: 'Agregar Tiempo de Activación',
      sendTarrifPassiveCalendar: 'Enviar Calendario Pasivo de Tarifas',
      requestActivateTimeProfilePassiveActivityCalendar:
        'Solicitar Tiempo de Activación del Calendario Pasivo',
      dmrcParams: 'Parámetros Relacionados con la Electricidad',
      setDmrcActiveStatus: 'Definir Estado del Perfil DMCR',
      setDmrcActivateTime: 'Agregar Tiempo de Activación DMCR',
      requestDmrcDayProfilePassive: 'Solicitar Tiempo de Activación del Calendario Pasivo DMCR',
      addDmrcDayPassiveCalendar: 'Agregar Día al Calendario Pasivo DMCR',
      setDmrcSwitch: 'Configurar Switch DMCR y UFER',
      requestDmrcSwitch: 'Solicitar Switch DMCR y UFER',
      readings: 'Parámetros Relacionados con Demandas',
      recoverRegisters: 'Recuperar Registros',
      getGeneralReadings: 'Recuperar Lecturas Generales',
    },
    daylightSavingTable: 'Horarios Registrados',
    finalDate: 'Fecha Inicial',
    endDate: 'Fecha Final',
    deviation: 'Desviación (minutos)',
    isEnable: 'Activo',
    confirmDelete: 'Confirmar Eliminación',
    deleteConfirmationMessage: '¿Desea realmente eliminar este horario?',
    deleteTarrifConfirmationMessage: '¿Desea realmente eliminar esta tarifa?',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    tarrifsTable: 'Tarifas Diarias',
    createDailyTariff: 'Crear Tarifa Diaria',
    day: 'Día',
    name: 'Nombre',
    description: 'Descripción',
    meterProfile: 'Perfil del Medidor',
    numberOfSchedules: 'Cantidad de Horarios',
    activateProfileActivityCalendar: 'Definir Estado del Perfil',
    serial: 'Serial',
    meter: 'Medidor',
    value: 'Valor',
    addTimeForActivation: 'Agregar Tiempo de Activación',
    activationDateTime: 'Fecha y Hora de Activación',
    save: 'Guardar',
    createDmrcCalendar: 'Crear Calendario DMCR',
    dayId: 'ID del Día',
    annualHoliday: 'Feriado anual',
    time: 'Horario',
    dmcrType: 'Tipo DMCR',
    createHolidayTemplate: 'Crear Plantilla de Feriado',
    deleteHolidayTemplate: 'Eliminar Plantilla de Feriado',
    holidayDate: 'Fecha del Feriado',
    index: 'Índice',
    addHoliday: 'Agregar Feriado',
    addIndex: 'Agregar índice',
    createDailyTariffTemplate: 'Crear Plantilla de Tarifa Diaria',
    hourlyTariffs: 'Tarifas por Horario',
    add: 'Agregar',
    tariffType: 'Tipo de Tarifa',
    createTimePeriodTemplate: 'Crear Plantilla de Período de Tiempo',
    deviationMinutes: 'Desviación (minutos)',
    active: 'Activo',
    dmcrSwitchConfiguration: 'Configuración del Switch DMCR',
    saturday: 'Sábado',
    sunday: 'Domingo',
    holiday: 'Feriado',
    workday: 'Día Laboral',
    capacitive: 'Capacitivo',
    inductive: 'Inductivo',
    send: 'Enviar',
    demandReading: 'Lectura de Demanda',
    demandTypes: 'Tipos de Demanda',
    selectDemands: 'Seleccione las demandas',
    generalReadings: 'Lecturas Generales',
    readings: 'Lecturas',
    selectReadings: 'Seleccione las lecturas',
    sendTariffPassiveCalendar: 'Enviar Calendario Pasivo de Tarifas',
    dailyTariffs: 'Tarifas Diarias',
    confirm: 'Confirmar',
    startDate: 'Fecha de Inicio',
    addDmrcActivateTime: 'Agregar Tiempo de Activación DMCR',
    setDmrcActiveStatus: 'Definir Estado del Perfil DMCR',
    editDailyTariff: 'Editar Tarifa Diaria',
    editTimePeriodTemplate: 'Editar Plantilla de Fecha',
    createTimePeriod: {
      title: 'Reemplazar registro existente',
      message:
        'Este medidor ya tiene un período de tiempo configurado. ¿Desea reemplazar el registro actual con la nueva información?',
    },
  },
  errors: {
    unauthorized: 'No tienes permiso para realizar esta acción.',
    notImplemented:
      'Acción no disponible en este momento. Este método aún no ha sido integrado al sistema.',
    deviceNotIdentified:
      'Dispositivo no identificado. Verifica si el serial está registrado e inténtalo de nuevo.',
    generic: 'Ocurrió un error al procesar tu solicitud.',
  },
  demands: {
    0: 'Energía activa importada total acumulada',
    1: 'Energía activa importada acumulada (tarifa 1)',
    2: 'Energía activa importada acumulada (tarifa 2)',
    3: 'Energía activa importada acumulada (tarifa 3)',
    4: 'Energía activa importada acumulada (tarifa 4)',
    5: 'Energía activa exportada total acumulada',
    6: 'Energía activa exportada acumulada (tarifa 1)',
    7: 'Energía activa exportada acumulada (tarifa 2)',
    8: 'Energía activa exportada acumulada (tarifa 3)',
    9: 'Energía activa exportada acumulada (tarifa 4)',
    10: 'Demanda actual de energía activa importada total',
    11: 'Demanda actual de energía activa importada (tarifa 1)',
    12: 'Demanda actual de energía activa importada (tarifa 2)',
    13: 'Demanda actual de energía activa importada (tarifa 3)',
    14: 'Demanda actual de energía activa importada (tarifa 4)',
    15: 'Demanda actual de energía activa exportada total',
    16: 'Demanda actual de energía activa exportada (tarifa 1)',
    17: 'Demanda actual de energía activa exportada (tarifa 2)',
    18: 'Demanda actual de energía activa exportada (tarifa 3)',
    19: 'Demanda actual de energía activa exportada (tarifa 4)',
    20: 'Demanda máxima de energía activa importada total',
    21: 'Demanda máxima de energía activa importada (tarifa 1)',
    22: 'Demanda máxima de energía activa importada (tarifa 2)',
    23: 'Demanda máxima de energía activa importada (tarifa 3)',
    24: 'Demanda máxima de energía activa importada (tarifa 4)',
    25: 'Demanda máxima de energía activa exportada total',
    26: 'Demanda máxima de energía activa exportada (tarifa 1)',
    27: 'Demanda máxima de energía activa exportada (tarifa 2)',
    28: 'Demanda máxima de energía activa exportada (tarifa 3)',
    29: 'Demanda máxima de energía activa exportada (tarifa 4)',
  },
  generalReadings: {
    0: 'Estado de la batería',
    1: 'Contador de facturación cerrado',
    2: 'Totalizador directo - General',
    3: 'Totalizador directo - Punta',
    4: 'Totalizador directo - Valle',
    5: 'Totalizador directo - Reservado',
    6: 'Totalizador directo - 4º período',
    7: 'Totalizador inverso - General',
    8: 'Totalizador inverso - Punta',
    9: 'Totalizador inverso - Valle',
    10: 'Totalizador inverso - Reservado',
    11: 'Totalizador inverso - Reservado',
    12: 'Reactiva inductiva directa - General',
    13: 'Reactiva inductiva directa - Punta',
    14: 'Reactiva inductiva directa - Valle',
    15: 'Reactiva inductiva directa - Reservado',
    16: 'Reactiva inductiva directa - 4º período',
    17: 'Reactiva capacitiva directa - General',
    18: 'Reactiva capacitiva directa - Punta',
    19: 'Reactiva capacitiva directa - Valle',
    20: 'Reactiva capacitiva directa - Reservado',
    21: 'Reactiva capacitiva directa - 4º período',
    22: 'Reactiva inductiva inversa - General',
    23: 'Reactiva inductiva inversa - Punta',
    24: 'Reactiva inductiva inversa - Valle',
    25: 'Reactiva inductiva inversa - Reservado',
    26: 'Reactiva inductiva inversa - 4º período',
    27: 'Reactiva capacitiva inversa - General',
    28: 'Reactiva capacitiva inversa - Punta',
    29: 'Reactiva capacitiva inversa - Valle',
    30: 'Reactiva capacitiva inversa - Reservado',
    31: 'Reactiva capacitiva inversa - 4º período',
    32: 'Demanda máxima - Directa total',
    33: 'Demanda máxima - Directa punta',
    34: 'Demanda máxima - Directa valle',
    35: 'Demanda máxima - Directa reservado',
    36: 'Demanda máxima - Directa tipo D',
    37: 'Demanda acumulada - Directa total',
    38: 'Demanda acumulada - Directa punta',
    39: 'Demanda acumulada - Directa valle',
    40: 'Demanda acumulada - Directa reservado',
    41: 'Demanda acumulada - Directa tipo D',
    42: 'Demanda máxima - Inversa total (punta)',
    43: 'Demanda máxima - Inversa punta',
    44: 'Demanda máxima - Inversa valle',
    45: 'Demanda máxima - Inversa reservado',
    46: 'Demanda máxima - Inversa tipo D',
    47: 'Demanda acumulada - Inversa total',
    48: 'Demanda acumulada - Inversa punta',
    49: 'Demanda acumulada - Inversa valle',
    50: 'Demanda acumulada - Inversa reservado',
    51: 'Demanda acumulada - Inversa tipo D',
    52: 'Total',
    53: 'Punta',
    54: 'Valle',
    55: 'Reservado',
    56: 'Punta',
    57: 'Valle',
    58: 'Reservado',
    59: 'Punta',
    60: 'Valle',
    61: 'Reservado',
  },
  qualityParameters: {
    drpViolationsChartTitle: 'Medidores por Violación DRP',
    serial: 'Serial',
    installation: 'Instalación',
    selectPeriod: 'Seleccionar Período',
    serialPlaceholder: 'Ingrese serial del medidor',
    installationPlaceholder: 'Buscar por instalación',
    searching: 'Buscando...',
    noResults: 'No se encontraron resultados',
    filters: 'Filtros',
    pendencies: 'Pendientes',
    meterWithoutReadings: 'Medidores sin lecturas',
    noData: 'No hay datos para ser exibidos',
    loading: 'Cargando',
    installationsAboveDicLimit: 'Instalaciones sobre el límite DIC',
    installationsAboveFicLimit: 'Instalaciones sobre el límite FIC',
    averageBaseDic: 'DIC Promedio Base',
    averageBaseFic: 'FIC Promedio Base',
    badInstalations: 'Instalaciones con Peores Indicadores',
    dic: 'DIC',
    fic: 'FIC',
    dicLimit: 'Límite DIC',
    ficLimit: 'Límite FIC',
    ficRegion: 'Región (FIC)',
    status: 'Estado',
    drcViolation: 'Medidores por Violación DRC',
    tensionVariation: 'Variación de Tensión Promedio Mensual',
    readingsByMonth: 'Lecturas por Mes',
    drpDrcAverage: 'Promedio Mensual DRP/DRC',
    drpDrcViolations: 'Violación Promedio DRP/DRC',
    monthlyDicFic: 'Valor Mensual DIC/FIC',
    interruptions: 'Interrupción de Energía',
    installationsAboveDrpLimit: 'Instalaciones por encima del límite de DRP',
    installationsAboveDrcLimit: 'Instalaciones por encima del límite de DRC',
    averageBaseDrp: 'DRP Medio Base',
    averageBaseDrc: 'DRC Medio Base',
    drp: 'DRP Mensual (%)',
    drc: 'DRC Mensual (%)',
    drpLimit: 'Límite de DRP',
    drcLimit: 'Límite de DRC',
    drpViolation: 'Violación DRP Mensual (%)',
    drcViolationT: 'Violación DRC Mensual (%)',
    statusGood: 'Bueno',
    statusAdequate: 'Adecuada',
    statusPrecarious: 'Precaria',
    statusCritical: 'Crítica',
    drpUpTo20: 'DRP hasta 20%',
    drpUpTo40: 'DRP hasta 40%',
    drpUpTo60: 'DRP hasta 60%',
    drpUpTo80: 'DRP hasta 80%',
    drpUpTo100: 'DRP 100%',
    drcUpTo20: 'DRC hasta 20%',
    drcUpTo40: 'DRC hasta 40%',
    drcUpTo60: 'DRC hasta 60%',
    drcUpTo80: 'DRC hasta 80%',
    drcUpTo100: 'DRC 100%',
    noInformation: 'Sin Información',
    selectCategories: 'Seleccionar categorías',
    state: 'Estado',
    city: 'Ciudad',
    selectState: 'Seleccione el estado',
    selectCity: 'Seleccione la ciudad',
    clear: 'Limpiar',
    apply: 'Aplicar',
    averageVoltage: 'Tensión Media',
    readings: 'Lecturas',
    voltage: 'Tensión',
    viewChart: 'Ver Gráfico',
    viewTable: 'Ver Tabla',
    exportMonthlySummary: 'Exportar Resumen Mensual',
    byMonth: 'Por Mes',
    byWeek: 'Por Semana',
    meters: 'Medidores',
    day: 'Día',
    week: 'Semana',
    drpPercent: 'DRP %',
    drcPercent: 'DRC %',
    drcViolationPercent: 'VIOLACIÓN DRC %',
    drpViolationPercent: 'VIOLACIÓN DRP %',
    dicHours: 'DIC (Horas)',
    dmicHours: 'DMIC (Horas)',
    drpBand20: 'DRP hasta 20%',
    drpBand40: 'DRP hasta 40%',
    drpBand60: 'DRP hasta 60%',
    drpBand80: 'DRP hasta 80%',
    drpBand100: 'DRP 100%',
    drcBand20: 'DRC hasta 20%',
    drcBand40: 'DRC hasta 40%',
    drcBand60: 'DRC hasta 60%',
    drcBand80: 'DRC hasta 80%',
    drcBand100: 'DRC 100%',
    averageV: 'Promedio (V)',
    phaseA: 'Fase A (V)',
    phaseB: 'Fase B (V)',
    phaseC: 'Fase C (V)',
    violationDrc: 'Violación DRC',
    violationDrp: 'Violación DRP',
    totalFicEvents: 'Total FIC (Eventos)',
    meterQuantity: 'Cant. Medidores',
    dicHoursCompact: 'DIC (Horas)',
    dmicHoursCompact: 'DMIC (Horas)',
    detailedIndicators: 'Indicadores Detallados',
    detailedDrpDrcViolations: 'Violaciones DRP/DRC Detalladas',
    detailedDicFic: 'Detalle DIC/FIC',
    detailedTensionLevels: 'Niveles de Tensión Detallados',
    averageDrp: 'DRP Promedio',
    averageDrc: 'DRC Promedio',
    createdAt: 'Fecha de Creación',
    manufacturer: 'Fabricante',
    model: 'Modelo',
    dateTime: 'Fecha/Hora',
    voltageReading: 'Lectura de Tensión',
    generalV: 'General (V)',
  },
}
